<!-- =========================================================================================
    File Name: FormWizardNumberTab.vue
    Description: Form wizard with numbers in tabs
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-row>
    <div class="mt-5 w-full">
      <form-wizard
        class="ml-1 mt-2"
        color="rgba(var(--vs-primary), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Add Card"
        ref="wiz"
      >
        <template slot="next">
          <vs-button class="ml-5 px-6 wizardBtnPad">Next</vs-button>
          <vs-button
            class="ml-5 px-6 wizardBtnPad"
            @click="SaveCardBeforeFinalTab"
            >Save Card</vs-button
          >
        </template>
        <template slot="prev">
          <vs-button class="ml-5 px-6 wizardBtnPad">Back</vs-button>
        </template>
        <template slot="finish">
          <vs-button class="ml-5 px-6 wizardBtnPad" @click="editCard"
            >Save Card</vs-button
          >
        </template>

        <tab-content
          title=""
          class="mb-5"
          :before-change="beforeFirstTabChange"
        >
          <!-- tab 1 content -->
          <vs-row class="tabCard">
            <vs-row>
              <h3 class="p-5">Card Details</h3>
            </vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
              <!-- <vs-input label="Issuer" class="w-full p-5" /> -->

              <div class="dropdown mt-1 w-full" id="dropdown">
                <div class="addCardFont font-semibold ml-5">
                  Issuer<span v-if="errors.issuerName.success" class="sterik">
                    *</span
                  >
                  <span v-if="!errors.issuerName.success"> *</span>
                </div>
                <vs-input
                  :danger="errors.issuerName.success"
                  :danger-text="errors.issuerName.msg"
                  class="w-full p-5 pt-4"
                  @click="handleFilter"
                  v-on-clickaway="closeColorList"
                  v-model="cardDetails.issuer.name"
                  readonly
                />
                <div class="dropdown-content" v-show="toggleColorList">
                  <div
                    class="colorItemContainer"
                    @click="cardDetails.issuer = issuer"
                    :key="index"
                    v-for="(issuer, index) in issuersList"
                  >
                    <div
                      class="colorIconStyle"
                      :style="{ 'background-color': issuer.color }"
                    ></div>
                    <span class="colorTextStyle">{{ issuer.name }}</span>
                  </div>
                </div>
              </div>
              <!-- <vs-select
                                autocomplete
                                class="w-full px-5 my-5 text-left"
                                label="Issuer"
                                
                                >
                                <vs-select-item :key="index" :value="item.name" :text="item.name" v-for="(item,index) in issuersList" />
                            </vs-select> -->
              <vs-row>
                <div class="addCardFont font-semibold ml-5">
                  Card Name<span v-if="errors.cardName.success" class="sterik">
                    *</span
                  >
                  <span v-if="!errors.cardName.success" class=""> *</span>
                </div>
                <vs-input
                  class="w-full p-5"
                  v-model="cardDetails.name"
                  :danger="errors.cardName.success"
                  :danger-text="errors.cardName.msg"
                  @input="validateCardName($event)"
                  maxLength="120"
                />
                <div class="addCardFont font-semibold ml-5">Card Type</div>
              </vs-row>
              <vs-row class="mt-2">
                <vs-radio
                  v-model="cardDetails.card_type"
                  vs-name="creditType"
                  vs-value="credit"
                  class="m-5 addCardFont textSize"
                  @change="cardDetails.card_type = 'credit'"
                  >Credit</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.card_type"
                  vs-name="creditType"
                  vs-value="charge"
                  class="m-5 addCardFont textSize"
                  @change="cardDetails.card_type = 'charge'"
                  >Charge</vs-radio
                >
              </vs-row>

              <vs-row
                class="p-5 m-5 ml-0"
                vs-type="flex"
                vs-justify="flex-start"
              >
                <vs-col vs-lg="10">
                  <div
                    @click="$refs.uploadAddCard.click()"
                    class="uploadLabelWizard"
                  >
                    {{ "Upload Card Picture" }}
                  </div>
                  <input
                    type="file"
                    class="hidden"
                    ref="uploadAddCard"
                    multiple
                    @change="showFilePath"
                  />
                </vs-col>

                <vs-col vs-lg="2" class="uploadContainerAddWizard">
                  <div class="btn-addon">
                    <vs-button
                      size="small"
                      color="primary"
                      @click="$refs.uploadAddCard.click()"
                    >
                      <UploadCloudIcon />
                    </vs-button>
                  </div>
                </vs-col>
                <vs-row class="">
                  <div v-show="errors.photo.success" class="">
                    <div id="errFont" class="dangerColor mt-3 ml-1">
                      <span class="">{{ errors.photo.msg }}</span>
                    </div>
                  </div>
                </vs-row>
              </vs-row>
              <vs-row v-if="previewPicture.length > 0">
                <vs-col vs-lg="10">
                  <vs-row>
                    <div
                      :key="index"
                      v-for="(picture, index) in previewPicture"
                      class="ml-4 addCardFont font-semibold mb-3"
                      @click="
                        imageclicked(picture.src, $ApiKeys.BASE_URL, picture)
                      "
                    >
                      <vs-dropdown>
                        <vue-load-image>
                          <img
                            v-bind:class="[
                              picture.defaultImage &&
                              picture.defaultImage == true
                                ? 'defaultImageStyle'
                                : 'ImageStyle',
                            ]"
                            v-if="picture.isEdited == false"
                            slot="image"
                            :src="
                              picture.src
                                ? $ApiKeys.BASE_URL + picture.src
                                : require('@/assets/images/no_preview.jpg')
                            "
                            height="45"
                            width="75"
                          />
                          <img
                            v-bind:class="[
                              picture.defaultImage &&
                              picture.defaultImage == true
                                ? 'defaultImageStyle'
                                : 'ImageStyle',
                            ]"
                            v-if="picture.isEdited == true"
                            slot="image"
                            :src="picture.src"
                            height="45"
                            width="75"
                          />

                          <img
                            v-bind:class="[
                              picture.defaultImage &&
                              picture.defaultImage == true
                                ? 'defaultImageStyle'
                                : 'ImageStyle',
                            ]"
                            slot="preloader"
                            src="@/assets/images/image-loader.gif"
                            height="45"
                            width="75"
                          />
                          <div slot="error">
                            <img
                              v-bind:class="[
                                picture.defaultImage &&
                                picture.defaultImage == true
                                  ? 'defaultImageStyle'
                                  : 'ImageStyle',
                              ]"
                              slot="image"
                              :src="require('@/assets/images/no_preview.jpg')"
                              height="45"
                              width="75"
                            />
                          </div>
                        </vue-load-image>
                        <vs-dropdown-menu>
                          <vs-dropdown-item @click="defaultImage(index)">
                            Mark as default
                          </vs-dropdown-item>
                          <!-- <vs-dropdown-item @click="imageclicked(picture.src)">
                            Zoom
                          </vs-dropdown-item> -->
                          <vs-dropdown-item
                            @click="removeCardImage(picture.src, index)"
                            divider
                          >
                            Remove
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
              <div class="addCardFont font-semibold ml-5">Product Change</div>
              <vs-row>
                <vs-col class="px-4 mt-5 pr-5">
                  <select
                    v-if="cardsList.length > 0"
                    v-model="cardDetails.product_change"
                    :class="{
                      'w-full posSelect p-3': true,
                      'mb-2': cardDetails.product_change,
                    }"
                    @change="handleCardFilter"
                  >
                    <option
                      v-for="card in cardsList"
                      :key="card._id"
                      :value="card._id"
                    >
                      {{ card.name }}
                    </option>
                  </select>
                  <select
                    v-else
                    class="w-full posSelect p-3 mb-2"
                    :disabled="true"
                  >
                    <option selected>No Cards Available</option>
                  </select>
                </vs-col>
              </vs-row>
              <div class="addCardFont font-semibold ml-5 mt-4">
                Upgrade Card
              </div>
              <vs-col class="px-4 mt-5 mb-3 pr-5">
                <select
                  v-if="cardsList.length > 0"
                  v-model="cardDetails.upgrade_card"
                  class="w-full posSelect p-3"
                  @change="handleCardFilter"
                >
                  <option
                    v-for="card in cardsList"
                    :key="card._id"
                    :value="card._id"
                  >
                    {{ card.name }}
                  </option>
                </select>
                <select v-else class="w-full posSelect p-3" :disabled="true">
                  <option selected>No Cards Available</option>
                </select>
              </vs-col>
              <div class="addCardFont font-semibold ml-5">Downgrade Card</div>
              <vs-row>
                <vs-col class="px-4 mt-5 pr-5">
                  <select
                    v-if="cardsList.length > 0"
                    v-model="cardDetails.downgrade_card"
                    class="w-full posSelect p-3 mt-2"
                    @change="handleCardFilter"
                  >
                    <option
                      v-for="card in cardsList"
                      :key="card._id"
                      :value="card._id"
                    >
                      {{ card.name }}
                    </option>
                  </select>
                  <select v-else class="w-full posSelect p-3" :disabled="true">
                    <option selected>No Cards Available</option>
                  </select>
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </tab-content>

        <tab-content
          title=""
          class="mb-5"
          :before-change="beforeSecondTabChange"
        >
          <vs-row class="tabCard">
            <vs-row>
              <h3 class="p-5">Annual Fees</h3>
            </vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
              <div class="addCardFont font-semibold ml-5">
                Annual Fee<span v-if="errors.annualFee.success" class="sterik">
                  *</span
                >
                <span v-if="!errors.annualFee.success"> *</span>
              </div>
              <vs-input
                maxlength="20"
                type="number"
                min="0"
                class="w-full p-5"
                v-model="cardDetails.annual_fee"
                :danger="errors.annualFee.success"
                :danger-text="errors.annualFee.msg"
                @input="calculateEffectiveFee"
                @keydown="validateNumeric($event)"
              />
              <!-- <vs-row id="editor"> -->

              <!-- </vs-row> -->
            </vs-col>
            <vs-col vs-lg="3" vs-sm="12" class="inputContainer">
              <div class="addCardFont font-semibold ml-5">
                International Transaction Fee
              </div>
              <vs-row class="mt-2">
                <vs-radio
                  v-model="cardDetails.international_transaction_status"
                  vs-name="type"
                  vs-value="yes"
                  class="m-5"
                  @change="updateInternationalTransaction('yes')"
                  >Yes</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.international_transaction_status"
                  vs-name="type"
                  vs-value="no"
                  class="m-5"
                  @change="updateInternationalTransaction('no')"
                  >No</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.international_transaction_status"
                  vs-name="type"
                  vs-value="NA"
                  class="m-5"
                  @change="updateInternationalTransaction('NA')"
                  >N/A</vs-radio
                >
              </vs-row>
            </vs-col>
            <vs-col
              vs-lg="3"
              vs-sm="12"
              class="inputContainer pt-2 max-height-5-24"
              vs-type="flex"
              vs-justify="center"
            >
              <vs-checkbox
                v-model="cardDetails.five_twenty_four"
                vs-name="rule-type"
                :vs-value="true"
                class="m-2 mt-5"
              />
              <div class="addCardFont font-semibold ml-0 mt-5 pt-6">
                Counts toward Chase 5/24
              </div>
            </vs-col>
            <vs-row>
              <div class="ml-4 mb-1 mt-5 mb-5 font-semibold">
                Add breakdown of Annual Fees to calculate Effective Fees
              </div>
            </vs-row>

            <div v-show="errors.feeCategory.success" class="ml-5 mb-3">
              <div id="errFont" class="dangerColor mt-3">
                <span>{{ errors.feeCategory.msg }}</span>
              </div>
            </div>
            <vs-row
              :key="index"
              v-for="(category, index) in cardDetails.fee_categories"
            >
              <vs-row class="my-2">
                <vs-col vs-lg="6" class="pr-6 pl-5 inputContainer">
                  <div class="addCardFont font-semibold">Credit Title</div>
                  <vs-input
                    maxLength="30"
                    placeholder="e.g Uber Credit"
                    class="w-full py-3"
                    v-model="cardDetails.fee_categories[index].credit_title"
                    :value="index"
                  />
                  <vs-col vs-lg="12">
                    <div class="addCardFont font-semibold pl-2 mt-1">
                      Amount
                    </div>
                    <vs-input
                      maxlength="20"
                      type="number"
                      min="0"
                      class="w-full py-3 inputContainer"
                      v-model="cardDetails.fee_categories[index].amount"
                      @input="calculateEffectiveFee"
                      @keydown="validateNumeric($event)"
                    />
                  </vs-col>
                  <vs-col vs-lg="12">
                    <div class="addCardFont font-semibold pl-2 mt-1">
                      Per Use Amount
                    </div>
                    <vs-input
                      maxlength="20"
                      type="number"
                      min="0"
                      class="w-full py-3 inputContainer"
                      v-model="cardDetails.fee_categories[index].per_use_amount"
                      @input="calculateEffectiveFee"
                      @keydown="validateNumeric($event)"
                    />
                  </vs-col>

                  <vs-col vs-lg="12">
                    <vs-row>
                      <vs-col vs-lg="6">
                        <div class="addCardFont font-semibold">Cutoff Date</div>
                      </vs-col>
                      <vs-col vs-lg="6">
                        <vs-row
                          class="
                            vs-row
                            inputContainer
                            max-height-5-24
                            alignRight
                          "
                          vs-type="flex"
                        >
                          <vs-checkbox
                            @click="setCreditCutoffNA(index)"
                            :checked="
                              cardDetails.fee_categories[index].na_cutoff
                            "
                            vs-name="rule-type"
                          />
                          <div class="text-white">N/A</div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <Datepicker
                      v-model="cardDetails.fee_categories[index].cutoff_date"
                      wrapper-class="py-5 pt-0 pb-0 my-3"
                      calendar-class="posCalendar"
                      input-class="bgColorInput"
                      placeholder="MM/DD/YYYY"
                      format="MM/dd/yyyy"
                      :disabled="cardDetails.fee_categories[index].na_cutoff"
                    />
                  </vs-col>

                  <vs-col vs-lg="12">
                    <div class="addCardFont font-semibold pl-2 mt-1">
                      Expiration Date Type
                    </div>
                    <!-- <vs-input maxlength="20" type="number" min="0" class="w-full py-3 inputContainer" v-model="cardDetails.fee_categories[index].amount" @input="calculateEffectiveFee" @keydown="validateNumeric($event)"/> -->
                    <select
                      v-model="
                        cardDetails.fee_categories[index].expiration_date_type
                      "
                      class="w-full posSelect my-5 px-2"
                    >
                      <option
                        v-for="exp in expiration_date_type_options"
                        :key="exp.value"
                        :value="exp.value"
                      >
                        {{ exp.name }}
                      </option>
                    </select>
                  </vs-col>

                  <vs-row
                    class="mb-5"
                    v-if="
                      cardDetails.fee_categories[index].expiration_date_type !=
                        '' &&
                      cardDetails.fee_categories[index].expiration_date_type !=
                        'custom_date' &&
                      cardDetails.fee_categories[index].expiration_date_type !=
                        'NA' &&
                      cardDetails.fee_categories[index].expiration_date_addition
                    "
                  >
                    <vs-col vs-lg="4">
                      <vs-row>
                        <div class="addCardFont font-semibold">Weeks</div>
                      </vs-row>
                      <vs-row>
                        <vs-input
                          class="w-full pr-5"
                          type="number"
                          min="0"
                          maxlength="20"
                          @keydown="validateNumeric($event)"
                          @change="onChangeCreditExpiry($event, index)"
                          v-model="
                            cardDetails.fee_categories[index]
                              .expiration_date_addition.weeks
                          "
                        />
                      </vs-row>
                    </vs-col>

                    <vs-col vs-lg="4">
                      <vs-row>
                        <div class="addCardFont font-semibold">Months</div>
                      </vs-row>
                      <vs-row>
                        <vs-input
                          class="w-full"
                          type="number"
                          min="0"
                          maxlength="20"
                          @keydown="validateNumeric($event)"
                          @change="onChangeCreditExpiry($event, index)"
                          v-model="
                            cardDetails.fee_categories[index]
                              .expiration_date_addition.months
                          "
                        />
                      </vs-row>
                    </vs-col>

                    <vs-col vs-lg="4">
                      <vs-row>
                        <div class="addCardFont font-semibold ml-5">Years</div>
                      </vs-row>
                      <vs-row>
                        <vs-input
                          class="w-full pl-5"
                          type="number"
                          min="0"
                          maxlength="20"
                          @keydown="validateNumeric($event)"
                          @change="onChangeCreditExpiry($event, index)"
                          v-model="
                            cardDetails.fee_categories[index]
                              .expiration_date_addition.years
                          "
                        />
                      </vs-row>
                    </vs-col>
                  </vs-row>

                  <vs-row
                    class="pb-5"
                    v-if="
                      cardDetails.fee_categories[index].expiration_date_type ==
                      'custom_date'
                    "
                  >
                    <vs-row
                      class="pb-3"
                      :key="date_index"
                      v-for="(custom_date, date_index) in cardDetails
                        .fee_categories[index].custom_dates"
                    >
                      <Datepicker
                        :disabled-dates="
                          cardDetails.fee_categories[index].custom_dates[
                            date_index - 1
                          ] && {
                            to: new Date(
                              new Date(
                                cardDetails.fee_categories[index].custom_dates[
                                  date_index - 1
                                ]
                              ).getTime() +
                                60 * 60 * 24 * 1000
                            ),
                          }
                        "
                        v-model="
                          cardDetails.fee_categories[index].custom_dates[
                            date_index
                          ]
                        "
                        wrapper-class="py-5 pr-5 mt-0 pt-0 pb-0"
                        calendar-class="posCalendar"
                        input-class="bgColorInput"
                        placeholder="MM/DD/YYYY"
                        format="MM/dd/yyyy"
                      />
                      <div
                        class="flex flex-wrap-reverse items-center cursor mt-1"
                        @click="
                          cardDetails.fee_categories[index].custom_dates.splice(
                            date_index,
                            1
                          )
                        "
                      >
                        <MinusSquareIcon size="20" color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove Date
                        </div>
                      </div>
                    </vs-row>

                    <div
                      class="flex flex-wrap-reverse items-center cursor"
                      @click="addCreditCustomDate(index)"
                    >
                      <PlusSquareIcon size="20" color="white" />
                      <h6 class="ml-2 cursor">Add Date</h6>
                    </div>
                  </vs-row>
                </vs-col>
                <vs-col
                  vs-lg="4"
                  class="pr-6 inputContainer pt-6 mt-3 tinymce-dynamic-wrapper"
                >
                  <Editor
                    v-model="cardDetails.fee_categories[index].description"
                    api-key="5nhm4pgf51fpuh0eu4mibhh6y67oxybsqctow1rpfvperrft"
                    :init="{
                      selector: 'textarea',
                      content_style: 'body, body a { color: white }',
                      width: '95%',
                      height: 290,
                      menubar: false,
                      plugins: 'link paste autolink',
                      default_link_target: '_blank',
                      toolbar:
                        'bold italic underline strikethrough | link anchor',
                    }"
                  />
                  <vs-col vs-lg="12" class="mt-2">
                    <vs-button
                      id="buttontext"
                      width="90%"
                      class="items-center cursor ml-4 mt-10"
                      @click="showBonusCategoryModel(index, 'fee')"
                      >Manage BonusCategories</vs-button
                    >
                  </vs-col>
                </vs-col>
                <vs-col vs-lg="2" class="flex">
                  <div
                    class="
                      flex flex-wrap-reverse
                      items-center
                      pl-3
                      fix-category-remove-btn
                      ml-5
                    "
                  >
                    <div
                      class="cursor flex flex-wrap-reverse items-center"
                      @click="removeCategoryItem(index)"
                    >
                      <MinusSquareIcon color="white" />
                      <div class="addCardFont font-semibold ml-3">Remove</div>
                    </div>
                  </div>
                </vs-col>
              </vs-row>
            </vs-row>
            <vs-row>
              <div
                class="flex flex-wrap-reverse items-center ml-5 cursor my-6"
                @click="addNewCredit"
              >
                <PlusSquareIcon color="white" />
                <div
                  id="whiteText"
                  class="addCardFont font-semibold ml-3 cursor"
                >
                  Add Credit
                </div>
              </div>
            </vs-row>
            <vs-col vs-lg="8" class="px-3 pr-0">
              <vs-row vs-justify="space-between" class="border-top p-3 pr-0">
                <div id="whiteText">Effective Fee</div>
                <div id="whiteText">
                  {{
                    calculatedFee >= 0
                      ? "$" + calculatedFee
                      : "-$" + calculatedFee * -1
                  }}
                </div>
              </vs-row>
            </vs-col>
          </vs-row>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content
          title=""
          class="mb-5 tabCard"
          :before-change="beforeThirdTabChange"
        >
          <vs-row>
            <vs-row>
              <h3 class="p-5">Point Details</h3>
            </vs-row>
            <vs-row
              v-if="
                cardDetails.points_categories &&
                cardDetails.points_categories.length > 0
              "
            >
              <vs-col vs-lg="9" vs-sm="12" vs-xs="12">
                <vs-row>
                  <div>
                    <h6 class="p-3 pl-5 valuation">Valuation</h6>
                  </div>

                  <div>
                    <vs-input
                      v-model="valuation"
                      maxlength="40"
                      type="number"
                      min="0"
                      class="pl-2"
                      placeholder="Enter Valuation"
                      @keydown="validateNumeric($event, true)"
                    />
                  </div>
                  <div>
                    <vs-button
                      class="ml-3"
                      @click="calculatePercentages"
                      :disabled="valuation <= 0"
                      >Calculate</vs-button
                    >
                  </div>
                  <vs-row>
                    <div class="mt-5 ml-3">
                      <vs-row>
                        <!-- <vs-checkbox
                          class="ml-2 mb-3"
                          vs-name="global_dynamic_bonus_category"
                          v-model="cardDetails.dynamic_bonus_category"
                        />
                        <div class="text-white smalltext">
                          Dynamic Bonus Category
                        </div> -->
                        <div
                          class="
                            flex flex-wrap-reverse
                            items-center
                            ml-2
                            mt-1
                            mb-6
                            cursor
                          "
                          @click="addDynamicBonusCategory"
                        >
                          <PlusSquareIcon color="white" />
                          <h6 class="ml-2 mt-1 cursor">
                            Create Dynamic Bonus Category
                          </h6>
                        </div>
                      </vs-row>
                    </div>
                  </vs-row>
                  <vs-row
                    v-if="
                      dynamic_bonus_categoires &&
                      dynamic_bonus_categoires.length > 0
                    "
                  >
                    <vs-row
                      :key="index"
                      v-for="(dynamic, index) in dynamic_bonus_categoires"
                    >
                      <vs-row>
                        <vs-col class="ml-5 mt-1" vs-lg="6">
                          <h6>Dynamic Bonus Category {{ index + 1 }}</h6>
                        </vs-col>
                        <vs-col vs-lg="5">
                          <div
                            class="
                              flex flex-wrap-reverse
                              items-center
                              ml-3
                              mr-5
                              cursor
                            "
                            @click="
                              dynamic_bonus_categoires.splice(index, 1),
                                removeDynamicBonusCategories(index)
                            "
                          >
                            <MinusSquareIcon color="white" />
                            <div class="addCardFont font-semibold ml-2 cursor">
                              Remove
                            </div>
                          </div>
                        </vs-col>
                      </vs-row>
                      <div class="ml-3">
                        <div class="mt-2 ml-2">Set Category Limit</div>
                        <vs-input
                          type="number"
                          min="0"
                          id="transparent"
                          v-model="dynamic_bonus_categoires[index].limit"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                        />
                      </div>
                    </vs-row>
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col vs-lg="3" vs-sm="12" vs-xs="12">
                <div class="p-3 pt-0 pr-0 pb-8">
                  <vs-row>
                    <div class="addCardFont ml-4 font-semibold cursor">
                      Points Description
                    </div>

                    <Editor
                      v-model="cardDetails.points_description"
                      api-key="5nhm4pgf51fpuh0eu4mibhh6y67oxybsqctow1rpfvperrft"
                      :init="{
                        selector: 'textarea',
                        content_style: 'body, body a { color: white }',
                        width: '90%',
                        menubar: false,
                        plugins: 'link paste autolink',
                        toolbar:
                          'bold italic underline strikethrough | link anchor',
                      }"
                    />
                  </vs-row>
                </div>
              </vs-col>
            </vs-row>
            <vs-row
              class="border-top ml-5 mr-4 pb-1"
              v-if="
                cardDetails.points_categories &&
                cardDetails.points_categories.length > 0
              "
            >
            </vs-row>
            <vs-row>
              <vs-col vs-lg="12 p-3" vs-sm="12 p-3">
                <vs-row
                  :key="index"
                  v-for="(category, index) in cardDetails.points_categories"
                >
                  <!-- <vs-col vs-lg="3" vs-sm="4" vs-xs="12" class="mt-5 px-2">
                   -->
                  <div class="mt-5 px-2">
                    <select
                      v-model="
                        cardDetails.points_categories[index].points_category
                      "
                      @change="categorychangeHandler(index)"
                      class="w-full posSelect p-3"
                    >
                      <option
                        v-for="cat in points_categories_option"
                        :key="cat._id"
                        :value="cat._id"
                      >
                        {{ cat.name }}
                      </option>
                    </select>
                  </div>
                  <!-- </vs-col> -->
                  <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                  <div
                    class="flex flex-wrap-reverse items-center ml-0 cursor my-6"
                  >
                    <vx-tooltip
                      text="Press the button to add a new point category if you did not find it in the list"
                      position="top"
                    >
                      <vs-row>
                        <PlusSquareIcon
                          color="white"
                          @click="showPointCategryModal('single', index, 0)"
                        />
                      </vs-row>
                    </vx-tooltip>
                  </div>
                  <div>
                    <vs-input
                      maxlength="3"
                      type="number"
                      min="0"
                      class="p-5 pl-2"
                      placeholder="Percentage"
                      v-model="cardDetails.points_categories[index].percentage"
                      @keydown="validateNumeric($event, true)"
                    />
                  </div>
                  <div>
                    <vs-input-number
                      v-model="cardDetails.points_categories[index].multiplier"
                      class="inline-flex m-6 mr-6"
                      min="0"
                    />
                  </div>

                  <div
                    v-if="cardDetails.points_categories[index].type == 'single'"
                    class="flex flex-wrap-reverse items-center ml-3 mr-5 cursor"
                    @click="removeSingleitemPointCategory(index)"
                  >
                    <MinusSquareIcon color="white" />
                    <div class="addCardFont font-semibold ml-2 cursor">
                      Remove
                    </div>
                  </div>
                  <div
                    v-if="cardDetails.points_categories[index].type == 'group'"
                    class="flex flex-wrap-reverse items-center ml-3 mr-5 cursor"
                    @click="removeGroupItem(index)"
                  >
                    <MinusSquareIcon color="white" />
                    <div class="addCardFont font-semibold ml-2 cursor">
                      Remove
                    </div>
                  </div>

                  <vs-col
                    vs-lg="3 mb-5"
                    vs-sm="3"
                    vs-xs="6 "
                    vs-type="flex"
                    vs-justify="flex-end"
                  >
                    <div>
                      <vs-button
                        id="buttontext"
                        width="90%"
                        class="items-center cursor mt-5"
                        @click="ManageSubcategory(index, 'show')"
                        >Manage Subcategories</vs-button
                      >
                    </div>
                  </vs-col>
                  <vs-row class="ml-0">
                    <vs-col vs-lg="9">
                      <vs-col
                        vs-lg="4"
                        class="mb-3"
                        :key="DynamicindexCat"
                        v-for="(dyn, DynamicindexCat) in cardDetails
                          .points_categories[index].dynamic_bonus_category"
                      >
                        <vs-row>
                          <vs-checkbox
                            class="ml-2 mb-3"
                            vs-name="global_dynamic_bonus_category"
                            v-model="
                              cardDetails.points_categories[index]
                                .dynamic_bonus_category[DynamicindexCat].isAdded
                            "
                          />
                          <div class="text-white smalltext">
                            Dynamic Bonus Category {{ DynamicindexCat + 1 }}
                          </div>
                        </vs-row>
                        <!-- <div>
                          <label class="container" style="padding-left: 24px"
                            >Dynamic Bonus Category {{ DynamicindexCat + 1 }}
                            <input
                              type="checkbox"
                              v-model="
                                cardDetails.points_categories[index]
                                  .dynamic_bonus_category[DynamicindexCat]
                                  .isAdded
                              "
                              v-bind:name="
                                'dynamic_bonus_category' +
                                index +
                                DynamicindexCat
                              "
                              value="true"
                              @click="changeIsAdded(index, DynamicindexCat)"
                            />
                            <span
                              class="checkmark"
                              style="border-radius: 2px"
                            ></span>
                          </label>
                        </div> -->
                      </vs-col>
                    </vs-col>
                  </vs-row>
                  <vs-row
                    v-if="cardDetails.points_categories[index].type == 'group'"
                  >
                    <vs-row
                      :key="Groupindex"
                      v-for="(Groupcategory, Groupindex) in cardDetails
                        .points_categories[index].groupCategories"
                    >
                      <div class="mt-5 px-2">
                        <select
                          v-model="
                            cardDetails.points_categories[index]
                              .groupCategories[Groupindex].points_category
                          "
                          class="w-full posSelect p-3"
                        >
                          <option
                            v-for="cat in points_categories_option"
                            :key="cat._id"
                            :value="cat._id"
                          >
                            {{ cat.name }}
                          </option>
                        </select>
                      </div>
                      <!-- </vs-col> -->
                      <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-0
                          cursor
                          my-6
                        "
                      >
                        <vx-tooltip
                          text="Press the button to add a new point category if you did not find it in the list"
                          position="top"
                        >
                          <vs-row>
                            <PlusSquareIcon
                              color="white"
                              @click="
                                showPointCategryModal(
                                  'group',
                                  index,
                                  Groupindex
                                )
                              "
                            />
                          </vs-row>
                        </vx-tooltip>
                      </div>
                      <div>
                        <vs-input
                          maxlength="3"
                          type="number"
                          min="0"
                          class="p-5 pl-2"
                          placeholder="Percentage"
                          v-model="
                            cardDetails.points_categories[index]
                              .groupCategories[Groupindex].percentage
                          "
                          @keydown="validateNumeric($event, true)"
                        />
                      </div>
                      <div>
                        <vs-input-number
                          v-model="
                            cardDetails.points_categories[index]
                              .groupCategories[Groupindex].multiplier
                          "
                          class="inline-flex m-6 mr-6"
                          min="0"
                        />
                      </div>
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-3
                          mr-5
                          cursor
                        "
                        @click="removeGroupPointsCategory(index, Groupindex)"
                      >
                        <MinusSquareIcon color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove
                        </div>
                      </div>
                      <vs-row class="ml-0">
                        <vs-col vs-lg="9">
                          <vs-col
                            vs-lg="4"
                            class="mb-3"
                            :key="Dynamicindex"
                            v-for="(dyn, Dynamicindex) in cardDetails
                              .points_categories[index].groupCategories[
                              Groupindex
                            ].dynamic_bonus_category"
                          >
                            <vs-row>
                              <vs-checkbox
                                class="ml-2 mb-3"
                                vs-name="global_dynamic_bonus_category"
                                v-model="
                                  cardDetails.points_categories[index]
                                    .groupCategories[Groupindex]
                                    .dynamic_bonus_category[Dynamicindex]
                                    .isAdded
                                "
                              />
                              <div class="text-white smalltext">
                                Dynamic Bonus Category {{ Dynamicindex + 1 }}
                              </div>
                            </vs-row>
                            <!-- <div>
                              <label
                                class="container"
                                style="padding-left: 24px"
                                >Dynamic Bonus Category {{ Dynamicindex + 1 }}
                                <input
                                  type="checkbox"
                                  v-model="
                                    cardDetails.points_categories[index]
                                      .groupCategories[Groupindex]
                                      .dynamic_bonus_category[Dynamicindex]
                                      .isAdded
                                  "
                                  v-bind:name="
                                    'dynamic_bonus_category' +
                                    index +
                                    Groupindex +
                                    Dynamicindex
                                  "
                                  value="true"
                                />
                                <span
                                  class="checkmark"
                                  style="border-radius: 2px"
                                ></span>
                              </label>
                            </div> -->
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                  </vs-row>

                  <vs-row
                    v-if="cardDetails.points_categories[index].type == 'group'"
                  >
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-2
                        mt-1
                        mb-6
                        cursor
                      "
                      @click="addPointCategoryGroupCategory(index)"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                    </div>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].points_category != ''
                    "
                  >
                    <vs-row>
                      <vs-checkbox
                        class="ml-2 mb-3"
                        v-model="
                          cardDetails.points_categories[index]
                            .manage_spend_limit
                        "
                        vs-name="manage_spend_limit"
                      />

                      <div class="text-white smalltext">Manage Spend Limit</div>
                    </vs-row>
                    <!-- <vs-col vs-lg="2" vs-sm="3"> -->
                    <!-- <div style="margin-right: 5%">
                      <vs-row>
                        <vs-checkbox
                          class="ml-2 mb-3"
                          v-model="
                            cardDetails.points_categories[index]
                              .manage_spend_limit
                          "
                          vs-name="manage_spend_limit"
                        />

                        <div class="text-white smalltext">
                          Manage Spend Limit
                        </div>
                      </vs-row>
                    </div> -->
                    <!-- </vs-col> -->
                    <!-- <vs-col vs-lg="3" vs-sm="3" style="margin-left: 5%"> -->
                    <!-- <div>
                      <vs-row>
                        <vs-checkbox
                          class="ml-2 mb-3"
                          v-model="
                            cardDetails.points_categories[index]
                              .dynamic_bonus_category
                          "
                          vs-name="dynamic_bonus_category"
                        />
                        <div class="text-white smalltext">
                          Dynamic Bonus Category
                        </div>
                      </vs-row>
                    </div> -->
                    <!-- </vs-col> -->
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit &&
                      cardDetails.points_categories[index]
                        .manage_spend_limit_options != undefined
                    "
                  >
                    <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                        <div class="mt-2 ml-2">Spend Limit</div>

                        <vs-input
                          type="number"
                          id="transparent"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                          v-model="
                            cardDetails.points_categories[index]
                              .manage_spend_limit_options.spend_limit
                          "
                          min="0"
                          @keydown="validateNumeric($event)"
                          @keyup="fixvalue(index, 'point_categories')"
                        />
                      </vs-col>

                      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                        <div class="mt-2 ml-2">Points Limit</div>
                        <vs-input
                          type="number"
                          id="transparent"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                          v-model="
                            cardDetails.points_categories[index]
                              .manage_spend_limit_options.points_limit
                          "
                          min="0"
                          @keydown="validateNumeric($event)"
                          @keyup="fixvalue(index, 'point_categories')"
                        />
                      </vs-col>
                    </vs-col>
                    <!-- <vs-col vs-lg="5" vs-sm="7" vs-xs="12">
                      <div class="mt-2 ml-2">Spend Limit</div>
                      <vs-input
                        type="number"
                        id="transparent"
                        class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                        v-model="
                          cardDetails.points_categories[index]
                            .manage_spend_limit_options.spend_limit
                        "
                        min="0"
                        @keydown="validateNumeric($event)"
                        @keyup="fixvalue(index, 'point_categories')"
                      />
                    </vs-col> -->
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit ==
                        true &&
                      cardDetails.points_categories[index]
                        .manage_spend_limit_options != undefined
                    "
                  >
                    <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                      <vs-row>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12" class="mr-0">
                          <label class="ml-2">Beginning Date </label>
                          <div
                            v-if="
                              cardDetails.points_categories[index]
                                .manage_spend_limit_options.date_type !=
                              'calendar_year'
                            "
                          >
                            <Datepicker
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.beginningDate
                              "
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                          <div v-else>
                            <Datepicker
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <label class="ml-2">End Date </label>
                          <div
                            v-if="
                              cardDetails.points_categories[index]
                                .manage_spend_limit_options.date_type !=
                              'calendar_year'
                            "
                          >
                            <Datepicker
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.endDate
                              "
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                          <div v-else>
                            <Datepicker
                              wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                              calendar-class="posCalendar"
                              input-class="bgColorInput"
                              placeholder="MM/DD/YYYY"
                              format="MM/dd/yyyy"
                            />
                          </div>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                    <!-- <vs-col vs-lg="6" vs-sm="8" vs-xs="12">
                      <vs-row>
                        <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="mr-4">
                          <label class="ml-2">Beginning Date </label>
                          <Datepicker
                            v-model="
                              cardDetails.points_categories[index]
                                .manage_spend_limit_options.beginningDate
                            "
                            wrapper-class="p-5 pl-2 mt-2 pt-0 pb-0 mb-2"
                            calendar-class="posCalendar"
                            input-class="bgColorInput"
                            placeholder="MM/DD/YYYY"
                            format="MM/dd/yyyy"
                          />
                        </vs-col>
                        <vs-col vs-lg="5" vs-sm="5" vs-xs="12">
                          <label class="ml-2">End Date </label>
                          <Datepicker
                            v-model="
                              cardDetails.points_categories[index]
                                .manage_spend_limit_options.endDate
                            "
                            wrapper-class="p-5 pl-2 mt-2 pt-0 pb-0 mb-2"
                            calendar-class="posCalendar"
                            input-class="bgColorInput"
                            placeholder="MM/DD/YYYY"
                            format="MM/dd/yyyy"
                          />
                        </vs-col>
                      </vs-row>
                    </vs-col> -->
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit ==
                        true &&
                      cardDetails.points_categories[index]
                        .manage_spend_limit_options != undefined
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Anniversary Year
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'anniversary_year',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'anniversary_year' + index"
                              value="anniversary_year"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="2 p-3 pb-3 "
                          vs-sm="3 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Recurring Monthly
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'recurring_monthly',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'recurring_monthly' + index"
                              value="recurring_monthly"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="2 pt-1 pb-3 p-3"
                          vs-sm="4 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Recurring Quarters
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'recurring_quarters',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'recurring_quarters' + index"
                              value="recurring_quarters"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit ==
                        true &&
                      cardDetails.points_categories[index]
                        .manage_spend_limit_options != undefined
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Calendar Year
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'calendar_year',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'calendar_year' + index"
                              value="calendar_year"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-0 pb-3 "
                          vs-sm="3 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q1
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'q1',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'q1' + index"
                              value="q1"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q2
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'q2',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'q2' + index"
                              value="q2"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3 pl-2"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q3
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'q3',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'q3' + index"
                              value="q3"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q4
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options.date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  cardDetails.points_categories[index]
                                    .manage_spend_limit_options,
                                  'q4',
                                  index,
                                  'point_categories'
                                )
                              "
                              v-bind:name="'q4' + index"
                              value="q4"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <!-- <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit
                    "
                    class="ml-2 mt-2"
                  >
                    <p>Does the spend limit apply to other categories?</p>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="9">
                        <vs-col
                          class="mr-2"
                          vs-lg="2 p-3 pt-2 pl-2"
                          vs-sm="4 pb-3 pt-2"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Yes
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options
                                  .apply_spend_limit_to_other_categories
                              "
                              v-bind:name="'true' + index"
                              value="true"
                              @click="changeSpendLimitOption(index, 'group')"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="2 pt-2 pb-3 " vs-sm="4 pt-2 pb-3">
                          <label class="container" style="padding-left: 24px"
                            >No
                            <input
                              type="radio"
                              v-model="
                                cardDetails.points_categories[index]
                                  .manage_spend_limit_options
                                  .apply_spend_limit_to_other_categories
                              "
                              v-bind:name="'false' + index"
                              value="false"
                              @click="changeSpendLimitOption(index, 'single')"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit &&
                      cardDetails.points_categories[index]
                        .manage_spend_limit_options
                        .apply_spend_limit_to_other_categories == 'true'
                    "
                    class="mt-2 ml-2"
                  >
                    <p>Choose other categories included in limit</p>
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.points_categories[index].manage_spend_limit &&
                      cardDetails.points_categories[index]
                        .manage_spend_limit_options
                        .apply_spend_limit_to_other_categories == 'true'
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="5 ml-2 mr-3">
                        <div class="mt-1">
                          <select
                            v-model="groupCat"
                            @change="AddCategoryToGroupHandler(index)"
                            class="w-full posSelect p-3"
                          >
                            <option
                              v-for="cat in points_categories_option"
                              :key="cat._id"
                              :value="cat"
                            >
                              {{ cat.name }}
                            </option>
                          </select>
                        </div>
                         <vs-col
                          vs-lg="2 p-3 pt-2 pl-4 "
                          vs-sm="3 pb-3 pt-2"
                          vs-xs="12"
                          class="optionlimit"
                          :key="ind"
                          v-for="(cat, ind) in cardDetails.points_categories[
                            index
                          ].groupCategories"
                        >
                          <label class="container" style="padding-left: 24px">
                            <div
                              v-if="
                                cardDetails.points_categories[index]
                                  .groupCategories[
                                  ind
                                ].name
                                  ? cardDetails.points_categories[index]
                                      
                                      .groupCategories[ind].name.length <= 10
                                  : 'NA'
                              "
                            >
                              {{
                                cardDetails.points_categories[index]
                                  .groupCategories[
                                  ind
                                ].name
                                  ? cardDetails.points_categories[index]
                                      
                                      .groupCategories[ind].name
                                  : "NA"
                              }}
                            </div>
                            <div v-else>
                              {{
                                cardDetails.points_categories[
                                  index
                                ].groupCategories[
                                  ind
                                ].name.substring(0, 10) + ".."
                              }}
                            </div>
                            <input
                              class="mt-3"
                              type="checkbox"
                              v-bind:name="'multiple_use_unlimited' + index"
                              value="multiple_use_unlimited"
                              v-model="
                                cardDetails.points_categories[index]
                                  .groupCategories[
                                  ind
                                ].category_in_limit
                              "
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col> 
                      </vs-col>
                      <vs-col>
                        <vs-row
                          v-for="categor in cardDetails.points_categories[index]
                            .groupCategories"
                          :key="categor._id"
                          :value="categor.name"
                        >
                          <h6>{{ categor.name }}</h6>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-row> -->

                  <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row>

                  <!-- <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row> -->
                </vs-row>
                <vs-row>
                  <div
                    v-show="errors.pointCategories.success"
                    class="ml-2 mb-3"
                  >
                    <div id="errFont" class="dangerColor mt-2">
                      <span>{{ errors.pointCategories.msg }}</span>
                    </div>
                  </div>
                </vs-row>
                <!-- <vs-row>
                  <div
                    class="flex flex-wrap-reverse items-center ml-2 mt-3 cursor"
                    @click="addPointCategory('single')"
                  >
                    <PlusSquareIcon color="white" />
                    <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                  </div>
                </vs-row> -->
                <vs-row>
                  <div
                    class="flex flex-wrap-reverse items-center ml-2 mt-3 cursor"
                    @click="addPointCategory('single')"
                  >
                    <PlusSquareIcon color="white" />
                    <h6 class="ml-2 mt-1 cursor">Add Bonus Category</h6>
                  </div>
                  <div
                    class="flex flex-wrap-reverse items-center ml-6 mt-3 cursor"
                    @click="addPointCategory('group')"
                  >
                    <PlusSquareIcon color="white" />
                    <h6 class="ml-2 mt-1 cursor">Add Bonus Category Group</h6>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
              <div class="border-top mt-10 ml-5 mb-1"></div>
            </vs-col>
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <h4 class="ml-5 mt-10 mb-5">Targeted Offers</h4>
              </vs-col>
            </vs-row>
            <vs-row>
              <div
                class="flex flex-wrap-reverse items-center ml-5 mt-3 cursor"
                @click="addMainTargetedOffer"
              >
                <PlusSquareIcon color="white" />
                <h6 class="ml-2 mt-1 cursor">Add Targeted Offer</h6>
              </div>
            </vs-row>
            <vs-row>
              <vs-col vs-lg="12 p-3" vs-sm="12 p-3">
                <vs-row
                  :key="index"
                  v-for="(category, index) in cardDetails.targeted_offers"
                >
                  <!-- <vs-col vs-lg="3" vs-sm="4" vs-xs="12" class="mt-5 px-2"> -->
                  <vs-row class="mt-5 mb-3 ml-2">
                    <vs-col vs-lg="7">
                      <h6 class="mt-1">Targeted Offer {{ index + 1 }}</h6>
                    </vs-col>
                    <vs-col vs-lg="4">
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-3
                          mr-5
                          cursor
                        "
                        @click="
                          cardDetails.targeted_offers.splice(index, 1),
                            updateAllTargetedlimitCategories()
                        "
                      >
                        <MinusSquareIcon color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove
                        </div>
                      </div>
                    </vs-col>
                  </vs-row>
                  <vs-row
                    :key="Bonusindex"
                    v-for="(bonuscategory, Bonusindex) in cardDetails
                      .targeted_offers[index].bonusCategory"
                  >
                    <vs-row
                      :key="categoryIndex"
                      v-for="(categories, categoryIndex) in cardDetails
                        .targeted_offers[index].bonusCategory[Bonusindex]
                        .categories"
                    >
                      <div class="mt-5 px-2">
                        <select
                          v-model="
                            cardDetails.targeted_offers[index].bonusCategory[
                              Bonusindex
                            ].categories[categoryIndex].points_category
                          "
                          @change="targetedofferchangehandler(Bonusindex)"
                          class="w-full posSelect p-3"
                        >
                          <option
                            v-for="cat in points_categories_option"
                            :key="cat._id"
                            :value="cat._id"
                          >
                            {{ cat.name }}
                          </option>
                        </select>
                      </div>
                      <!-- </vs-col> -->
                      <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-0
                          cursor
                          my-6
                        "
                      >
                        <vx-tooltip
                          text="Press the button to add a new point category if you did not find it in the list"
                          position="top"
                        >
                          <vs-row>
                            <PlusSquareIcon
                              color="white"
                              @click="
                                showPointCategryModalForTargetedOffer(
                                  index,
                                  Bonusindex,
                                  categoryIndex
                                )
                              "
                            />
                          </vs-row>
                        </vx-tooltip>
                      </div>
                      <div>
                        <vs-input
                          maxlength="3"
                          type="number"
                          min="0"
                          class="p-5 pl-2"
                          placeholder="Percentage"
                          v-model="
                            cardDetails.targeted_offers[index].bonusCategory[
                              Bonusindex
                            ].categories[categoryIndex].percentage
                          "
                          @keydown="validateNumeric($event, true)"
                        />
                      </div>
                      <div>
                        <vs-input-number
                          v-model="
                            cardDetails.targeted_offers[index].bonusCategory[
                              Bonusindex
                            ].categories[categoryIndex].multiplier
                          "
                          class="inline-flex m-6 mr-6"
                          min="0"
                        />
                      </div>

                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-3
                          mr-5
                          cursor
                        "
                        @click="
                          updateAllTargetedlimitCategories(),
                            removeTargetedOfferCategory(
                              index,
                              Bonusindex,
                              categoryIndex
                            )
                        "
                      >
                        <MinusSquareIcon color="white" />
                        <div class="addCardFont font-semibold ml-2 cursor">
                          Remove
                        </div>
                      </div>
                      <vs-row class="ml-0">
                        <vs-col vs-lg="9">
                          <vs-col
                            vs-lg="4"
                            class="mb-3"
                            :key="Dynamicindex"
                            v-for="(dyn, Dynamicindex) in cardDetails
                              .targeted_offers[index].bonusCategory[Bonusindex]
                              .categories[categoryIndex].dynamic_bonus_category"
                          >
                            <vs-row>
                              <vs-checkbox
                                class="ml-2 mb-3"
                                vs-name="global_dynamic_bonus_category"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex].categories[
                                    categoryIndex
                                  ].dynamic_bonus_category[Dynamicindex].isAdded
                                "
                              />
                              <div class="text-white smalltext">
                                Dynamic Bonus Category {{ Dynamicindex + 1 }}
                              </div>
                            </vs-row>
                            <!-- <div>
                              <label
                                class="container"
                                style="padding-left: 24px"
                                >Dynamic Bonus Category {{ Dynamicindex + 1 }}
                                <input
                                  type="checkbox"
                                  v-model="
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex].categories[
                                      categoryIndex
                                    ].dynamic_bonus_category[Dynamicindex]
                                      .isAdded
                                  "
                                  v-bind:name="
                                    'dynamic_bonus_category' +
                                    index +
                                    Bonusindex +
                                    categoryIndex +
                                    Dynamicindex
                                  "
                                  value="true"
                                />
                                <span
                                  class="checkmark"
                                  style="border-radius: 2px"
                                ></span>
                              </label>
                            </div> -->
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].category_type == 'group'
                      "
                    >
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-2
                          mt-0
                          mb-3
                          cursor
                        "
                        @click="addTargetedOfferCategory(index, Bonusindex)"
                      >
                        <PlusSquareIcon color="white" />
                        <h6 class="ml-2 mt-1 cursor">Add Category</h6>
                      </div>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].points_category != ''
                      "
                    >
                      <!-- <vs-col vs-lg="3" vs-sm="3"> -->
                      <div class="mt-1">
                        <vs-row>
                          <vs-checkbox
                            class="ml-2 mb-3"
                            v-model="
                              cardDetails.targeted_offers[index].bonusCategory[
                                Bonusindex
                              ].manage_spend_limit
                            "
                            vs-name="target_manage_spend_limit"
                          />

                          <div class="text-white smalltext">
                            Manage Spend Limit
                          </div>
                        </vs-row>
                      </div>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit &&
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit_options != undefined
                      "
                    >
                      <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <div class="mt-2 ml-2">Spend Limit</div>
                          <vs-input
                            type="number"
                            min="0"
                            id="transparent"
                            class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                            v-model="
                              cardDetails.targeted_offers[index].bonusCategory[
                                Bonusindex
                              ].manage_spend_limit_options.spend_limit
                            "
                            @keyup="
                              fixvalue(index, 'targeted_offers', Bonusindex)
                            "
                          />
                        </vs-col>

                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <div class="mt-2 ml-2">Points Limit</div>
                          <vs-input
                            type="number"
                            min="0"
                            id="transparent"
                            class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                            v-model="
                              cardDetails.targeted_offers[index].bonusCategory[
                                Bonusindex
                              ].manage_spend_limit_options.points_limit
                            "
                            @keyup="
                              fixvalue(index, 'targeted_offers', Bonusindex)
                            "
                          />
                        </vs-col>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit &&
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit_options != undefined
                      "
                    >
                      <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                        <vs-row>
                          <vs-col vs-lg="6" vs-sm="5" vs-xs="12" class="mr-0">
                            <label class="ml-2">Beginning Date </label>
                            <div
                              v-if="
                                cardDetails.targeted_offers[index]
                                  .bonusCategory[Bonusindex]
                                  .manage_spend_limit_options.date_type !=
                                'calendar_year'
                              "
                            >
                              <Datepicker
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.beginningDate
                                "
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                            <div v-else>
                              <Datepicker
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                          </vs-col>
                          <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                            <label class="ml-2">End Date </label>
                            <div
                              v-if="
                                cardDetails.targeted_offers[index]
                                  .bonusCategory[Bonusindex]
                                  .manage_spend_limit_options.date_type !=
                                'calendar_year'
                              "
                            >
                              <Datepicker
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.endDate
                                "
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                            <div v-else>
                              <Datepicker
                                wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                                calendar-class="posCalendar"
                                input-class="bgColorInput"
                                placeholder="MM/DD/YYYY"
                                format="MM/dd/yyyy"
                              />
                            </div>
                          </vs-col>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit == true &&
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit_options != undefined
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                          <vs-col
                            vs-lg="2 p-3 pt-1 pl-2"
                            vs-sm="4 pb-3 pt-1"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Anniversary Year
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'anniversary_year',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="
                                  'target_anniversary_year' + index + Bonusindex
                                "
                                value="anniversary_year"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="2 p-3 pt-1 pl-2"
                            vs-sm="4 pb-3 pt-1"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Recurring Monthly
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'recurring_monthly',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="
                                  'target_recurring_monthly' +
                                  index +
                                  Bonusindex
                                "
                                value="recurring_monthly"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="2 p-3 pt-1 pl-2"
                            vs-sm="4 pb-3 pt-1"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Recurring Quarters
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'recurring_quarters',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="
                                  'target_recurring_quarters' +
                                  index +
                                  Bonusindex
                                "
                                value="recurring_quarters"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit == true &&
                        cardDetails.targeted_offers[index].bonusCategory[
                          Bonusindex
                        ].manage_spend_limit_options != undefined
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                          <vs-col
                            vs-lg="2 p-3 pt-1 pl-2"
                            vs-sm="4 pb-3 pt-1"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Calendar Year
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'calendar_year',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="
                                  'target_calendar_year' + index + Bonusindex
                                "
                                value="calendar_year"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-0 pb-3 "
                            vs-sm="3 pt-1 pb-3"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q1
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q1',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="'target_q1' + index + Bonusindex"
                                value="q1"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-1 pb-3"
                            vs-sm="4 pt-1 pb-3"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q2
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q2',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="'target_q2' + index + Bonusindex"
                                value="q2"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-1 pb-3"
                            vs-sm="4 pt-1 pb-3 pl-2"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q3
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q3',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="'target_q3' + index + Bonusindex"
                                value="q3"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                          <vs-col
                            vs-lg="1 pt-1 pb-3"
                            vs-sm="4 pt-1 pb-3"
                            vs-xs="6"
                          >
                            <label class="container" style="padding-left: 24px"
                              >Q4
                              <input
                                type="radio"
                                v-model="
                                  cardDetails.targeted_offers[index]
                                    .bonusCategory[Bonusindex]
                                    .manage_spend_limit_options.date_type
                                "
                                @click="
                                  SetCategoriesDate(
                                    cardDetails.targeted_offers[index]
                                      .bonusCategory[Bonusindex]
                                      .manage_spend_limit_options,
                                    'q4',
                                    index,
                                    'targeted_offers',
                                    Bonusindex
                                  )
                                "
                                v-bind:name="'target_q4' + index + Bonusindex"
                                value="q4"
                              />
                              <span class="checkmark"></span>
                            </label>
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-lg="9">
                        <div class="border-top mt-5 ml-2 mb-1"></div>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <!-- <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row> -->
                  <vs-row>
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-2
                        mt-3
                        cursor
                      "
                      @click="addTargetedOfferBonusCategory(index, 'single')"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Bonus Category</h6>
                    </div>
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-6
                        mt-3
                        cursor
                      "
                      @click="addTargetedOfferBonusCategory(index, 'group')"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Bonus Category Group</h6>
                    </div>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row>
                </vs-row>
                <vs-row>
                  <div v-show="errors.targetedOffers.success" class="ml-2 mb-3">
                    <div id="errFont" class="dangerColor mt-2">
                      <span>{{ errors.targetedOffers.msg }}</span>
                    </div>
                  </div>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-row>
          <vs-row>
            <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
              <div class="border-top mt-10 ml-5 mb-1"></div>
            </vs-col>
            <vs-row
              v-if="
                userAddedBonusCategoryList &&
                userAddedBonusCategoryList.length > 0
              "
            >
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <h4 class="ml-5 mt-10 mb-5">User Added Bonus Categories</h4>
              </vs-col>
            </vs-row>
            <vs-row>
              <!-- <div
                class="flex flex-wrap-reverse items-center ml-5 mt-3 cursor"
                @click="addMainTargetedOffer"
              >
                <PlusSquareIcon color="white" />
                <h6 class="ml-2 mt-1 cursor">Add Targeted Offer</h6>
              </div> -->
            </vs-row>
            <vs-row
              v-if="
                userAddedBonusCategoryList &&
                userAddedBonusCategoryList.length > 0
              "
            >
              <vs-col vs-lg="12 p-3" vs-sm="12 p-3">
                <vs-row
                  :key="index"
                  v-for="(category, index) in userAddedBonusCategoryList"
                >
                  <!-- <vs-col vs-lg="3" vs-sm="4" vs-xs="12" class="mt-5 px-2"> -->
                  <vs-row class="mt-5 mb-3 ml-2">
                    <vs-col vs-lg="5">
                      <h6 class="mt-1">Bonus Category {{ index + 1 }}</h6>
                    </vs-col>
                    <vs-col vs-lg="7">
                      <vs-row>
                        <vs-button
                          v-if="AllApproved"
                          :disabled="true"
                          color="rgb(61, 189, 61) none repeat scroll 0% 0%"
                          style="
                            border-color: rgb(142, 136, 136);
                            border-width: 0.1rem;
                            border-style: solid;
                          "
                          @click="confirmDelete = true"
                          >User Added Categories Approved</vs-button
                        >
                        <vs-button
                          v-if="!AllApproved"
                          :disabled="true"
                          color="#d9534f"
                          style="
                            border-color: rgb(142, 136, 136);
                            border-width: 0.1rem;
                            border-style: solid;
                          "
                          @click="confirmDelete = true"
                          >User Added Categories Not Approved</vs-button
                        >
                        <vs-button
                          class="ml-5 px-6 wizardBtnPad"
                          @click="savepointcategory(index)"
                          >Approve</vs-button
                        >
                        <vs-button
                          class="ml-3"
                          color="#1D2024"
                          style="
                            border-color: rgb(142, 136, 136);
                            border-width: 0.1rem;
                            border-style: solid;
                          "
                          @click="rejectUserAddedCategory(index)"
                          >Deny</vs-button
                        >
                      </vs-row>
                    </vs-col>
                  </vs-row>

                  <vs-row
                    :key="categoryIndex"
                    v-for="(
                      categories, categoryIndex
                    ) in userAddedBonusCategoryList[index].categories"
                  >
                    <div
                      v-if="
                        userAddedBonusCategoryList[index].categories[
                          categoryIndex
                        ].isExistingPointCategory == false
                      "
                      class="mt-2 px-2"
                    >
                      <vs-input
                        id="transparent"
                        class="w-full mt-2 pr-3"
                        v-model="
                          userAddedBonusCategoryList[index].categories[
                            categoryIndex
                          ].customCategoryName
                        "
                      />
                    </div>
                    <div
                      v-if="
                        userAddedBonusCategoryList[index].categories[
                          categoryIndex
                        ].isExistingPointCategory == true
                      "
                      class="mt-5 px-2"
                    >
                      <select
                        v-model="
                          userAddedBonusCategoryList[index].categories[
                            categoryIndex
                          ].points_category
                        "
                        class="w-full posSelect p-3"
                        style="width: 210px !important"
                      >
                        <option
                          v-for="cat in points_categories_option"
                          :key="cat._id"
                          :value="cat._id"
                        >
                          {{ cat.name }}
                        </option>
                      </select>
                    </div>
                    <!-- </vs-col> -->
                    <!-- <div class="addCardFont font-semibold ml-3 cursor">{{ category.name }}</div>  -->
                    <div>
                      <vs-input
                        type="number"
                        min="0"
                        class="p-5 pl-2"
                        placeholder="Percentage"
                        v-model="
                          userAddedBonusCategoryList[index].categories[
                            categoryIndex
                          ].percentage
                        "
                        @keydown="validateNumeric($event, true)"
                      />
                    </div>
                    <div>
                      <vs-input-number
                        v-model="
                          userAddedBonusCategoryList[index].categories[
                            categoryIndex
                          ].multiplier
                        "
                        class="inline-flex m-6 mr-6"
                        min="0"
                      />
                    </div>

                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-3
                        mr-5
                        cursor
                      "
                      @click="
                        userAddedBonusCategoryList[index].categories.splice(
                          categoryIndex,
                          1
                        )
                      "
                    >
                      <MinusSquareIcon color="white" />
                      <div class="addCardFont font-semibold ml-2 cursor">
                        Remove
                      </div>
                    </div>

                    <!-- </vs-col> -->

                    <!-- <vs-col class="mt-2" vs-lg="3"> -->
                    <!-- <vs-row v-if="categoryIndex == 0">
                        <vs-button class="ml-5 px-6 wizardBtnPad"
                          >Approve</vs-button
                        >
                        <vs-button
                          class="ml-3"
                          color="#1D2024"
                          style="
                            border-color: rgb(142, 136, 136);
                            border-width: 0.1rem;
                            border-style: solid;
                          "
                          >Deny</vs-button
                        >
                      </vs-row> -->
                    <!-- </vs-col> -->
                    <!-- <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-3
                        mr-5
                        cursor
                      "
                      @click="
                        updateAllTargetedlimitCategories(),
                          removeTargetedOfferCategory(
                            index,
                            Bonusindex,
                            categoryIndex
                          )
                      "
                    >
                      <MinusSquareIcon color="white" />
                      <div class="addCardFont font-semibold ml-2 cursor">
                        Remove
                      </div>
                    </div> -->
                  </vs-row>

                  <vs-row v-if="userAddedBonusCategoryList[index].type != ''">
                    <!-- <vs-col vs-lg="3" vs-sm="3"> -->
                    <div class="mt-1">
                      <vs-row>
                        <vs-checkbox
                          class="ml-2 mb-3"
                          v-model="
                            userAddedBonusCategoryList[index].manage_spend_limit
                          "
                          vs-name="target_manage_spend_limit"
                        />

                        <div class="text-white smalltext">
                          Manage Spend Limit
                        </div>
                      </vs-row>
                    </div>
                  </vs-row>
                  <vs-row
                    v-if="userAddedBonusCategoryList[index].manage_spend_limit"
                  >
                    <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                        <div class="mt-2 ml-2">Spend Limit</div>
                        <vs-input
                          type="number"
                          min="0"
                          id="transparent"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                          v-model="
                            userAddedBonusCategoryList[index].spend_limit
                          "
                        />
                      </vs-col>

                      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                        <div class="mt-2 ml-2">Points Limit</div>
                        <vs-input
                          type="number"
                          min="0"
                          id="transparent"
                          class="w-full p-3 pt-2 pl-0 ml-2 mb-2"
                          v-model="
                            userAddedBonusCategoryList[index].points_limit
                          "
                        />
                      </vs-col>
                    </vs-col>
                  </vs-row>
                  <vs-row
                    v-if="userAddedBonusCategoryList[index].manage_spend_limit"
                  >
                    <vs-col vs-lg="5" vs-sm="8" vs-xs="12">
                      <vs-row>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12" class="mr-0">
                          <label class="ml-2">Beginning Date </label>
                          <Datepicker
                            v-model="
                              userAddedBonusCategoryList[index].beginningDate
                            "
                            wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                            calendar-class="posCalendar"
                            input-class="bgColorInput"
                            placeholder="MM/DD/YYYY"
                            format="MM/dd/yyyy"
                          />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <label class="ml-2">End Date </label>
                          <Datepicker
                            v-model="userAddedBonusCategoryList[index].endDate"
                            wrapper-class="p-5 pr-1 pl-2 mt-2 pt-0 pb-0 mb-2"
                            calendar-class="posCalendar"
                            input-class="bgColorInput"
                            placeholder="MM/DD/YYYY"
                            format="MM/dd/yyyy"
                          />
                        </vs-col>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-row
                    v-if="
                      userAddedBonusCategoryList[index].manage_spend_limit ==
                      true
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Anniversary Year
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'anniversary_year',
                                  index
                                )
                              "
                              v-bind:name="'userAdded_anniversary_year' + index"
                              value="anniversary_year"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Recurring Monthly
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'recurring_monthly',
                                  index
                                )
                              "
                              v-bind:name="
                                'userAdded_recurring_monthly' + index
                              "
                              value="recurring_monthly"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Recurring Quarters
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'recurring_quarters',
                                  index
                                )
                              "
                              v-bind:name="
                                'userAdded_recurring_quarters' + index
                              "
                              value="recurring_quarters"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <vs-row
                    v-if="
                      userAddedBonusCategoryList[index].manage_spend_limit ==
                      true
                    "
                  >
                    <vs-row
                      class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                      vs-type="flex"
                    >
                      <vs-col vs-lg="11" vs-sm="11" vs-xs="12">
                        <vs-col
                          vs-lg="2 p-3 pt-1 pl-2"
                          vs-sm="4 pb-3 pt-1"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Calendar Year
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'calendar_year',
                                  index
                                )
                              "
                              v-bind:name="'userAdded_calendar_year' + index"
                              value="calendar_year"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-0 pb-3 "
                          vs-sm="3 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q1
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'q1',
                                  index
                                )
                              "
                              v-bind:name="'userAdded_q1' + index"
                              value="q1"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q2
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'q2',
                                  index
                                )
                              "
                              v-bind:name="'userAdded_q2' + index"
                              value="q2"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3 pl-2"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q3
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'q3',
                                  index
                                )
                              "
                              v-bind:name="'userAdded_q3' + index"
                              value="q3"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col
                          vs-lg="1 pt-1 pb-3"
                          vs-sm="4 pt-1 pb-3"
                          vs-xs="6"
                        >
                          <label class="container" style="padding-left: 24px"
                            >Q4
                            <input
                              type="radio"
                              v-model="
                                userAddedBonusCategoryList[index].date_type
                              "
                              @click="
                                SetCategoriesDate(
                                  userAddedBonusCategoryList[index],
                                  'q4',
                                  index
                                )
                              "
                              v-bind:name="'userAdded_q4' + index"
                              value="q4"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                  <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row>

                  <!-- <vs-row>
                    <vs-col vs-lg="9">
                      <div class="border-top mt-5 ml-2 mb-1"></div>
                    </vs-col>
                  </vs-row> -->
                  <!-- <vs-row>
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-2
                        mt-3
                        cursor
                      "
                      @click="addTargetedOfferBonusCategory(index, 'single')"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Bonus Category</h6>
                    </div>
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-6
                        mt-3
                        cursor
                      "
                      @click="addTargetedOfferBonusCategory(index, 'group')"
                    >
                      <PlusSquareIcon color="white" />
                      <h6 class="ml-2 mt-1 cursor">Add Bonus Category Group</h6>
                    </div>
                  </vs-row> -->
                </vs-row>
                <!-- <vs-row>
                  <div v-show="errors.targetedOffers.success" class="ml-2 mb-3">
                    <div id="errFont" class="dangerColor mt-2">
                      <span>{{ errors.targetedOffers.msg }}</span>
                    </div>
                  </div>
                </vs-row> -->
              </vs-col>
            </vs-row>
          </vs-row>
          <vs-row v-if="SubCategorypoints.show == true">
            <vs-row>
              <vs-col vs-offset="7">
                <transition name="fade">
                  <div class="modal">
                    <div class="modal__backdrop">
                      <div class="modal__dialog">
                        <div class="modal__header">
                          <slot name="header">
                            <h4 style="margin-left: 20px">
                              Manage Subcategories
                            </h4>
                            <vue-load-image>
                              <img
                                class="ml-1 topright"
                                slot="image"
                                :src="require('@/assets/images/x/close.png')"
                                height="50"
                                width="47"
                                @click="BacktoMainCategories()"
                              />
                            </vue-load-image>
                          </slot>
                        </div>

                        <div class="modal__body">
                          <vs-row class="catBgClr mx-4">
                            <vs-col vs-lg="12" vs-sm="8" vs-xs="12">
                              <p class="pl-5 pb-6 pt-0 mb-0 mt-2 whiteText">
                                You may drag the fields to change the order
                              </p>
                            </vs-col>
                            <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

                            <vs-row>
                              <vs-col vs-lg="8" vs-sm="8" class="">
                                <vs-row>
                                  <vs-col vs-lg="12" vs-sm="12" vs-xs="9">
                                    <div class="my-2 ml-5">Category</div>
                                    <vs-input
                                      id="transparent"
                                      class="w-full p-3 ml-2"
                                      :disabled="true"
                                      v-model="SubCategorypoints.name"
                                    />
                                  </vs-col>
                                </vs-row>
                              </vs-col>
                            </vs-row>

                            <vs-row>
                              <div
                                class="
                                  flex flex-wrap-reverse
                                  items-center
                                  ml-5
                                  cursor
                                  mt-4
                                  mb-3
                                  pt-0
                                "
                                @click="addNewSubCategory()"
                              >
                                <PlusSquareIcon color="white" />
                                <h6 class="ml-2 mt-1 cursor">
                                  Add Subcategory
                                </h6>
                              </div>
                            </vs-row>
                            <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

                            <draggable
                              v-model="SubCategorypoints.subcategory"
                              v-bind="dragOptions"
                              class="w-full"
                            >
                              <transition-group
                                type="transition"
                                name="flip-list"
                              >
                                <vs-row
                                  :key="index"
                                  v-for="(
                                    category, index
                                  ) in SubCategorypoints.subcategory"
                                  class="ml-5"
                                >
                                  <vs-col
                                    vs-lg="8"
                                    vs-sm="8"
                                    vs-xs="6"
                                    class="pr-6"
                                    id="inputBorder"
                                  >
                                    <vs-row>
                                      <vs-col class="mt-6 pt-1" vs-lg="1">
                                        <MenuIcon class="mt-6" />
                                      </vs-col>
                                      <vs-col vs-lg="11">
                                        <div class="my-2 pt-1 ml-1">
                                          Subcategory {{ index + 1 }}
                                        </div>

                                        <select
                                          v-if="
                                            points_categories_option.length > 0
                                          "
                                          v-model="
                                            SubCategorypoints.subcategory[index]
                                              .category
                                          "
                                          :class="{
                                            'w-full posSelect  pl-3': true,
                                          }"
                                          @change="handleSelect(index)"
                                        >
                                          <option selected>
                                            {{
                                              SubCategorypoints.subcategory[
                                                index
                                              ].name
                                            }}
                                          </option>
                                          <option
                                            v-for="categor in points_categories_option"
                                            :key="categor._id"
                                            :value="categor._id"
                                          >
                                            {{ categor.name }}
                                          </option>
                                        </select>
                                      </vs-col>
                                    </vs-row>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-sm="3"
                                    vs-xs="12"
                                    vs-type="flex"
                                    vs-justify="flex-start"
                                  >
                                    <div
                                      v-if="
                                        SubCategorypoints.subcategory[index]
                                          .isDeleteable ||
                                        SubCategorypoints.subcategory[index]
                                          .isDeleteable == undefined
                                      "
                                      class="
                                        flex flex-wrap-reverse
                                        items-center
                                        cursor
                                        mt-5
                                        pl-4
                                      "
                                      @click="removeSubCategory(index)"
                                    >
                                      <MinusSquareIcon
                                        color="white"
                                        class="mt-5"
                                      />
                                      <div
                                        class="
                                          addCardFont
                                          font-semibold
                                          ml-3
                                          cursor
                                          mt-6
                                        "
                                      >
                                        Remove
                                      </div>
                                    </div>

                                    <div
                                      v-if="
                                        SubCategorypoints.subcategory[index]
                                          .isDeleteable == false
                                      "
                                      class="cursor mt-5 pt-0 ml-1"
                                      style="opacity: 0.3"
                                    >
                                      <vx-tooltip
                                        text="This category cannot be deleted since it is in use by cards"
                                        position="top"
                                      >
                                        <vs-row>
                                          <MinusSquareIcon
                                            color="white"
                                            class="mt-5"
                                          />
                                          <div
                                            class="
                                              addCardFont
                                              font-semibold
                                              ml-3
                                              cursor
                                              mt-6
                                            "
                                          >
                                            Remove
                                          </div>
                                        </vs-row>
                                      </vx-tooltip>
                                    </div>
                                  </vs-col>
                                </vs-row>
                              </transition-group>
                            </draggable>
                            <div
                              v-show="errors.subCategory.success"
                              class="ml-16 mb-3"
                            >
                              <div id="errFont" class="dangerColor mt-3 ml-1">
                                <span>{{ errors.subCategory.msg }}</span>
                              </div>
                            </div>
                          </vs-row>

                          <vs-row class="mt-16 pr-2 mb-1" vs-justify="center">
                            <vs-col vs-lg="9" vs-sm="9" vs-xs="0"> </vs-col>
                            <vs-col vs-lg="3" vs-sm="3" vs-xs="12">
                              <vs-button
                                style="width: 138px"
                                @click="updateCardSubCategories()"
                                >Save</vs-button
                              >
                            </vs-col>
                          </vs-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
              </vs-col>
            </vs-row>
          </vs-row>
        </tab-content>

        <tab-content
          title=""
          class="mb-5 tabCard"
          :before-change="beforePerksTabChange"
        >
          <vs-row>
            <vs-row class="ml-3">
              <h3 class="p-5">Perks</h3>
            </vs-row>
            <div v-show="errors.perks.success" class="ml-5 mb-3">
              <div id="errFont" class="dangerColor mt-3 ml-3">
                <span>{{ errors.perks.msg }}</span>
              </div>
            </div>
            <vs-row :key="index" v-for="(category, index) in cardDetails.perks">
              <vs-row v-if="cardDetails.perks[index].show == true">
                <vs-col vs-lg="6 p-3" vs-sm="12 p-3">
                  <vs-row class="inputContainer">
                    <div class="addCardFont font-semibold ml-5">Category</div>
                    <vs-input
                      class="w-full p-5 pt-3"
                      placeholder="e.g. Free Night"
                      maxLength="30"
                      v-model="cardDetails.perks[index].category"
                    />
                  </vs-row>

                  <vs-row class="inputContainer">
                    <vs-row>
                      <vs-col vs-lg="6">
                        <div class="addCardFont font-semibold ml-5">
                          Estimated Value
                        </div>
                      </vs-col>
                      <vs-col vs-lg="6">
                        <vs-row
                          class="
                            vs-row
                            inputContainer
                            max-height-5-24
                            alignRight
                            pr-5
                          "
                          vs-type="flex"
                        >
                          <vs-checkbox
                            @click="setPerkEstimatedNA(index)"
                            :checked="cardDetails.perks[index].na_estimated_val"
                            vs-name="rule-type"
                            :disabled="cardDetails.perks[index].disable"
                          />
                          <div class="text-white">N/A</div>
                        </vs-row>
                      </vs-col>
                    </vs-row>

                    <vs-input
                      placeholder="$150"
                      class="w-full p-5 pt-3"
                      type="number"
                      min="0"
                      maxlength="20"
                      @keydown="validateNumeric($event)"
                      v-model="cardDetails.perks[index].estimated_value"
                      :disabled="
                        cardDetails.perks[index].na_estimated_val ||
                        cardDetails.perks[index].disable
                      "
                    />
                  </vs-row>

                  <vs-row class="inputContainer">
                    <div class="addCardFont font-semibold ml-5">Key Date</div>
                    <select
                      v-if="cardDetails.perks[index].token == undefined"
                      v-model="cardDetails.perks[index].key_date"
                      class="w-full posSelect m-5 mt-3 mb-2 px-2"
                      v-on:change="
                        onKeyDateChanged(
                          cardDetails.perks[index].key_date,
                          index
                        )
                      "
                      :disabled="cardDetails.perks[index].disable"
                    >
                      <option
                        v-for="p in perks_key_date_option"
                        :key="p.value"
                        :value="p.value"
                      >
                        {{ p.name }}
                      </option>
                    </select>

                    <select
                      v-if="cardDetails.perks[index].token != undefined"
                      v-model="cardDetails.perks[index].key_date"
                      class="w-full posSelect m-5 mt-3 mb-2 px-2"
                      v-on:change="
                        onKeyDateChanged(
                          cardDetails.perks[index].key_date,
                          index
                        )
                      "
                      :disabled="cardDetails.perks[index].disable"
                    >
                      <option
                        v-for="p in earned_perks_key_date_option"
                        :key="p.value"
                        :value="p.value"
                      >
                        {{ p.name }}
                      </option>
                    </select>

                    <vs-row
                      class="mb-5"
                      v-if="
                        cardDetails.perks[index].key_date != '' &&
                        cardDetails.perks[index].key_date != 'custom_date' &&
                        cardDetails.perks[index].key_date != 'NA' &&
                        cardDetails.perks[index].key_date !=
                          'elite_year_january' &&
                        cardDetails.perks[index].key_date !=
                          'elite_year_february' &&
                        cardDetails.perks[index].key_date !=
                          'elite_year_march' &&
                        cardDetails.perks[index].key_date_addition &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Weeks
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            maxlength="20"
                            @keydown="validateNumeric($event)"
                            @change="onChangePerkKeyDateAddition($event, index)"
                            v-model="
                              cardDetails.perks[index].key_date_addition.weeks
                            "
                          />
                        </vs-row>
                      </vs-col>

                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Months
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            maxlength="20"
                            @keydown="validateNumeric($event)"
                            @change="onChangePerkKeyDateAddition($event, index)"
                            v-model="
                              cardDetails.perks[index].key_date_addition.months
                            "
                          />
                        </vs-row>
                      </vs-col>

                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Years
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            maxlength="20"
                            @keydown="validateNumeric($event)"
                            @change="onChangePerkKeyDateAddition($event, index)"
                            v-model="
                              cardDetails.perks[index].key_date_addition.years
                            "
                          />
                        </vs-row>
                      </vs-col>
                    </vs-row>

                    <vs-row
                      class="pb-5"
                      v-if="
                        cardDetails.perks[index].key_date == 'custom_date' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="pb-3"
                        :key="date_index"
                        v-for="(custom_date, date_index) in cardDetails.perks[
                          index
                        ].custom_dates"
                      >
                        <Datepicker
                          :disabled-dates="
                            cardDetails.perks[index].custom_dates[
                              date_index - 1
                            ] && {
                              to: new Date(
                                new Date(
                                  cardDetails.perks[index].custom_dates[
                                    date_index - 1
                                  ]
                                ).getTime() +
                                  60 * 60 * 24 * 1000
                              ),
                            }
                          "
                          v-model="
                            cardDetails.perks[index].custom_dates[date_index]
                          "
                          wrapper-class="p-5 mt-0 pt-0 pb-0"
                          calendar-class="posCalendar"
                          input-class="bgColorInput"
                          placeholder="MM/DD/YYYY"
                          format="MM/dd/yyyy"
                        />
                        <div
                          class="
                            flex flex-wrap-reverse
                            items-center
                            cursor
                            mt-1
                          "
                          @click="
                            cardDetails.perks[index].custom_dates.splice(
                              date_index,
                              1
                            )
                          "
                        >
                          <MinusSquareIcon size="20" color="white" />
                          <div class="addCardFont font-semibold ml-2 cursor">
                            Remove Date
                          </div>
                        </div>
                      </vs-row>

                      <div
                        class="flex flex-wrap-reverse items-center ml-5 cursor"
                        @click="cardDetails.perks[index].custom_dates.push('')"
                      >
                        <PlusSquareIcon size="20" color="white" />
                        <h6 class="ml-2 cursor">Add Date</h6>
                      </div>
                    </vs-row>

                    <vs-row>
                      <div class="addCardFont font-semibold ml-5">
                        Date Type
                      </div>
                      <select
                        v-model="cardDetails.perks[index].date_type"
                        class="w-full posSelect m-5 mb-3 mt-3 px-2"
                        :disabled="
                          cardDetails.perks[index].key_date == 'NA' ||
                          cardDetails.perks[index].disable
                        "
                      >
                        <option
                          v-for="pd in perks_date_type_option"
                          :key="pd.value"
                          :value="pd.value"
                        >
                          {{ pd.name }}
                        </option>
                      </select>
                    </vs-row>

                    <vs-row>
                      <div class="addCardFont font-semibold ml-5 mt-2">
                        Call to Action Button
                      </div>

                      <select
                        v-model="cardDetails.perks[index].call_to_action"
                        class="w-full posSelect m-5 mb-2 mt-3 px-2"
                        @change="CallToActionButton(index)"
                        :disabled="cardDetails.perks[index].disable"
                      >
                        <template
                          v-if="
                            cardDetails.perks[index].token &&
                            cardDetails.perks[index].token != ''
                          "
                        >
                          <option
                            v-for="pc in earned_perks_call_to_action_options"
                            :key="pc.value"
                            :value="pc.value"
                          >
                            {{ pc.name }}
                          </option>
                        </template>
                        <template v-else>
                          <option
                            v-for="pc in perks_call_to_action_options"
                            :key="pc.value"
                            :value="pc.value"
                          >
                            {{ pc.name }}
                          </option>
                        </template>
                      </select>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_earned_status' &&
                        !cardDetails.perks[index].disables
                      "
                      class="vs-row inputContainer max-height-5-24 ml-4"
                      vs-type="flex"
                    >
                      <!-- <vs-checkbox
                        v-model="
                          cardDetails.perks[index].earned_status.add_new_perk
                        "
                        @change="AddnewPerkhandler(index)"
                        vs-name="rule-type"
                        class="pt-1"
                      /> -->
                      <div class="font-semibold ml-2 pt-5 text-white">
                        Add Earned Perk
                      </div>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_usage' &&
                        cardDetails.perks[index].track_usage &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5" vs-sm="6 p-3">
                          <label class="container"
                            >Single Use (One Time-Only)
                            <input
                              type="radio"
                              v-bind:name="'single_use_one_time' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="single_use_one_time"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-3 " vs-sm="6 pt-3 pb-2">
                          <label class="container"
                            >Single Use
                            <input
                              type="radio"
                              v-bind:name="'single_use' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="single_use"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>

                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5 pt-3 " vs-sm="6 p-3">
                          <label class="container"
                            >Multiple use (limited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_limited' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="multiple_use_limited"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="6 pt-3 pb-3">
                          <label class="container"
                            >Multiple use (unlimited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_unlimited' + index"
                              v-model="
                                cardDetails.perks[index].track_usage
                                  .option_value
                              "
                              value="multiple_use_unlimited"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_usage' &&
                        cardDetails.perks[index].track_usage &&
                        cardDetails.perks[index].track_usage.option_value ==
                          'multiple_use_limited' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Choose # of limit
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].track_usage
                                .multiple_use_limit
                            "
                          />
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'mark_as_enrolled' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5" vs-sm="6 p-3">
                          <label class="container"
                            >Enrollment With No Expiration
                            <input
                              type="radio"
                              v-bind:name="
                                'enrollment_with_no_expiration' + index
                              "
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .option_value
                              "
                              value="enrollment_with_no_expiration"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-3 pb-3" vs-sm="6 pt-3 pb-3">
                          <label class="container"
                            >Enrollment With Expiration
                            <input
                              type="radio"
                              v-bind:name="'enrollment_with_expiration' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .option_value
                              "
                              value="enrollment_with_expiration"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>

                      <vs-row
                        v-if="
                          cardDetails.perks[index].date_type == 'expiration' &&
                          cardDetails.perks[index].key_date ==
                            'enrollment_date' &&
                          cardDetails.perks[index].call_to_action ==
                            'mark_as_enrolled' &&
                          cardDetails.perks[index].mark_as_enrolled
                            .option_value == 'enrollment_with_expiration' &&
                          !cardDetails.perks[index].disable
                        "
                      >
                        <vs-row>
                          <div
                            class="
                              addCardFont
                              whiteText
                              font-semibold
                              ml-5
                              mt-2
                              mb-1
                            "
                          >
                            Master Cut-off Date
                          </div>
                        </vs-row>
                        <vs-row>
                          <Datepicker
                            v-model="
                              cardDetails.perks[index].mark_as_enrolled
                                .master_cutoff_date
                            "
                            wrapper-class="w-full p-5 mt-2 pt-0"
                            calendar-class="posCalendar"
                            input-class="bgColorInput"
                            placeholder="MM/DD/YYYY"
                            format="MM/dd/yyyy"
                          />
                        </vs-row>
                      </vs-row>

                      <vs-row>
                        <div class="addCardFont font-semibold ml-5 mt-2">
                          Track Usage Type
                        </div>
                      </vs-row>
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5" vs-sm="6 p-3">
                          <label class="container"
                            >Single Use (One Time-Only)
                            <input
                              type="radio"
                              v-bind:name="'single_use_one_time' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="single_use_one_time"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-3 " vs-sm="6 pt-3 pb-2">
                          <label class="container"
                            >Single Use
                            <input
                              type="radio"
                              v-bind:name="'single_use' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="single_use"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>

                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5"
                        vs-type="flex"
                      >
                        <vs-col vs-lg="6 p-3 pl-5 pt-3 " vs-sm="6 p-3">
                          <label class="container"
                            >Multiple use (limited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_limited' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="multiple_use_limited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="6 pt-3 pb-3">
                          <label class="container"
                            >Multiple use (unlimited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_unlimited' + index"
                              v-model="
                                cardDetails.perks[index].mark_as_enrolled
                                  .track_usage_type
                              "
                              value="multiple_use_unlimited"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>
                    </vs-row>

                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'mark_as_enrolled' &&
                        cardDetails.perks[index].mark_as_enrolled &&
                        cardDetails.perks[index].mark_as_enrolled
                          .track_usage_type == 'multiple_use_limited' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-col vs-lg="4">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Choose # of limit
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].mark_as_enrolled
                                .multiple_use_limit
                            "
                          />
                        </vs-row>
                      </vs-col>
                    </vs-row>

                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_earned_tiers' &&
                        cardDetails.perks[index].track_earned_tiers &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-row
                        class="vs-row inputContainer max-height-5-24 pr-5 mt-2"
                        vs-type="flex"
                      >
                        <vs-col
                          vs-lg="6 p-3 pl-5"
                          vs-sm="6 pb-3 pl-3 pr-3 pt-1"
                        >
                          <label class="container"
                            >Multiple Use (Unlimited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_unlimited' + index"
                              v-model="
                                cardDetails.perks[index].track_earned_tiers
                                  .option_value
                              "
                              value="multiple_use_unlimited"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                        <vs-col vs-lg="6 pt-1 pb-3 pl-8" vs-sm="6 pt-1 pb-3">
                          <label class="container"
                            >Multiple Use (Limited)
                            <input
                              type="radio"
                              v-bind:name="'multiple_use_limited' + index"
                              v-model="
                                cardDetails.perks[index].track_earned_tiers
                                  .option_value
                              "
                              value="multiple_use_limited"
                              @change="temphandler()"
                            />
                            <span class="checkmark"></span>
                          </label>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                    <vs-row
                      v-if="
                        cardDetails.perks[index].call_to_action ==
                          'track_earned_tiers' &&
                        cardDetails.perks[index].track_earned_tiers
                          .option_value != '' &&
                        !cardDetails.perks[index].disable
                      "
                    >
                      <vs-col vs-lg="6">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Input text
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="text"
                            placeholder="e.g., 1,000 TQPs"
                            v-model="
                              cardDetails.perks[index].track_earned_tiers
                                .input_text
                            "
                          />
                        </vs-row>
                      </vs-col>
                      <vs-col vs-lg="6">
                        <vs-row>
                          <div class="addCardFont font-semibold ml-5 mb-1">
                            Choose # of limit
                          </div>
                        </vs-row>
                        <vs-row>
                          <vs-input
                            class="w-full px-5"
                            type="number"
                            min="0"
                            @keydown="validateNumeric($event)"
                            v-model="
                              cardDetails.perks[index].track_earned_tiers
                                .number_of_limit
                            "
                          />
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </vs-row>
                </vs-col>
                <vs-col vs-lg="6 p-3" vs-sm="12 p-3">
                  <vs-row>
                    <div class="addCardFont font-semibold ml-4 cursor pb-5">
                      Description
                    </div>
                    <Editor
                      v-model="cardDetails.perks[index].description"
                      :disabled="cardDetails.perks[index].disable"
                      api-key="5nhm4pgf51fpuh0eu4mibhh6y67oxybsqctow1rpfvperrft"
                      :init="{
                        selector: 'textarea',
                        content_style: 'body, body a { color: white }',
                        width: '95%',
                        menubar: false,
                        plugins: 'link paste autolink',
                        toolbar:
                          'bold italic underline strikethrough | link anchor',
                      }"
                    />
                  </vs-row>

                  <vs-row class="mt-5">
                    <div
                      class="
                        flex flex-wrap-reverse
                        items-center
                        ml-6
                        cursor
                        mt-1
                      "
                      @click="removePerk(index)"
                    >
                      <MinusSquareIcon color="white" />
                      <div class="addCardFont font-semibold ml-3 cursor">
                        Remove
                      </div>
                    </div>
                  </vs-row>
                  <vs-row
                    class="vs-row inputContainer pt-2 max-height-5-24 ml-5"
                    vs-type="flex"
                  >
                    <vs-checkbox
                      @click="setPerkDisplay(index)"
                      :checked="!cardDetails.perks[index].hide_on_dashboard"
                      vs-name="rule-type"
                      class="mt-4"
                    />
                    <div class="font-semibold ml-2 pt-4 text-white">
                      Display on Dashboard
                    </div>
                  </vs-row>
                  <vs-row>
                    <vs-button
                      id="buttontext"
                      width="90%"
                      class="items-center cursor ml-4 mt-10"
                      @click="showBonusCategoryModel(index, 'perks')"
                      >Manage BonusCategories</vs-button
                    >
                  </vs-row>
                  <vs-row
                    v-if="
                      cardDetails.perks[index].key_date != 'custom_date' &&
                      cardDetails.perks[index].key_date != 'NA'
                    "
                    class="vs-row inputContainer pt-2 max-height-5-24 ml-5"
                    vs-type="flex"
                  >
                    <vs-checkbox
                      @click="setPerkExpiration(index)"
                      :checked="
                        cardDetails.perks[index].no_first_year_expiration
                      "
                      vs-name="rule-type"
                      class="mt-4"
                    />
                    <div class="font-semibold ml-2 pt-4 text-white">
                      No First Year Expiration
                    </div>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-row>

            <vs-row class="ml-3">
              <div
                class="flex flex-wrap-reverse items-center ml-5 mt-3 cursor"
                @click="addPerk"
              >
                <PlusSquareIcon color="white" />
                <h6 class="ml-2 mt-1 cursor">Add Perk</h6>
              </div>
            </vs-row>
          </vs-row>
        </tab-content>
        <!-- tab 3 content -->
        <tab-content title="" class="mb-5 tabCard">
          <vs-row>
            <vs-row>
              <h3
                class="p-5 pb-2"
                v-if="modifiedList && modifiedList.length > 0"
              >
                Add Active Rules
              </h3>
            </vs-row>
            <vs-row>
              <p
                class="p-5"
                id="whiteText"
                v-if="modifiedList && modifiedList.length > 0"
              >
                Do you want to add active rules for this card?
              </p>
              <p
                class="p-5"
                id="whiteText"
                v-if="modifiedList && modifiedList.length == 0"
              >
                No active rules available for this Issuer
              </p>
            </vs-row>
            <vs-row v-if="modifiedList && modifiedList.length > 0">
              <vs-row v-if="errors.rules.success">
                <p id="errFont" class="p-5 py-3 dangerColor">
                  {{ errors.rules.msg }}
                </p>
              </vs-row>
              <vs-row id="whiteText">
                <vs-radio
                  v-model="cardDetails.active_rules_check"
                  vs-name="rule"
                  vs-value="Yes"
                  class="m-5"
                  @change="updateRule('Yes')"
                  >Yes</vs-radio
                >
                <vs-radio
                  v-model="cardDetails.active_rules_check"
                  vs-name="rule"
                  vs-value="No"
                  class="m-5"
                  @change="updateRule('No')"
                  >No</vs-radio
                >
              </vs-row>
              <vs-row
                :key="index"
                v-for="(rule, index) in cardDetails.activeRules"
                v-bind:class="{
                  hidder: cardDetails.active_rules_check == 'No',
                }"
              >
                <vs-col
                  vs-lg="6"
                  vs-sm="12"
                  class="px-3 pl-4"
                  id="ruleOptionContainer"
                >
                  <div class="my-2">Active Rule {{ index + 1 }}</div>
                  <select
                    v-model="cardDetails.activeRules[index].rule"
                    class="w-full posSelect p-3"
                  >
                    <option
                      v-for="option in modifiedList"
                      :key="option._id"
                      :value="option._id"
                    >
                      {{ option.rule }}
                    </option>
                  </select>
                </vs-col>
                <vs-col vs-lg="3" vs-sm="6">
                  <div class="my-2 ml-5">Effective Dates</div>
                  <Datepicker
                    v-model="cardDetails.activeRules[index].effectiveDate"
                    wrapper-class="p-5 mt-0 pt-0"
                    calendar-class="posCalendar"
                    input-class="bgColorInput"
                    placeholder="MM/DD/YYYY"
                    format="MM/dd/yyyy"
                  />
                </vs-col>
                <vs-col vs-lg="3" vs-sm="6">
                  <div
                    class="
                      flex flex-wrap-reverse
                      items-center
                      ml-6
                      cursor
                      mt-6
                      pl-6
                      pt-6
                    "
                    @click="cardDetails.activeRules.splice(index, 1)"
                  >
                    <MinusSquareIcon color="white" />
                    <div class="addCardFont font-semibold ml-3 cursor">
                      Remove
                    </div>
                  </div>
                </vs-col>
              </vs-row>
              <vs-row
                v-bind:class="{
                  hidder: cardDetails.active_rules_check == 'No',
                }"
              >
                <div
                  class="flex flex-wrap-reverse items-center ml-5 cursor"
                  @click="addNewRule"
                >
                  <PlusSquareIcon color="white" />
                  <h6 class="ml-2 mt-1 cursor">Add Rule</h6>
                </div>
              </vs-row>
            </vs-row>
          </vs-row>
        </tab-content>
        <modal
          :pointsCategoriesOption="points_categories_option"
          :showModal="showModal"
          :bonusindex="bonusIndex"
          :bonusCategory="BonusCategoryData"
          @close_modal_success="closeModalonSuccess"
          @close_modal_dismiss="closeModalonDismiss"
        ></modal>

        <pointCategorymodal
          :pointsCategoriesOption="pointsCategoriesOptionList"
          :showModal="showModal1"
          @close_modal_success="closeModalonSuccess1"
          @close_modal_dismiss="closeModalonDismiss1"
        ></pointCategorymodal>
      </form-wizard>
    </div>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="showDeleteStatus.status"
    >
      <h5>
        {{ showDeleteStatus.msg }}
      </h5>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="userAddedCategory.status"
    >
      <h5>{{ userAddedCategory.msg }}</h5>
    </vs-popup>
    <vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="askPointCategoryRemove.success"
      >
        <div style="magine-bottom: 30px" class="mb-5">
          <h5>{{ askPointCategoryRemove.msg }}</h5>
        </div>

        <div
          style="text-align: center; margin-top: 30px"
          vs-type="flex"
          vs-justify="center"
        >
          <vs-button
            class="mt-11 mr-5"
            @click="removeNewPointCategory()"
            color="primary"
            type="filled"
            >Yes</vs-button
          >
          <vs-button
            class="mt-11 ml-5"
            @click="keepNewPointCategory()"
            color="primary"
            type="filled"
            >No</vs-button
          >
        </div>
      </vs-popup>
    </vs-row>
  </vs-row>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  UploadCloudIcon,
  PlusSquareIcon,
  MinusSquareIcon,
  MenuIcon,
} from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";
import Datepicker from "vuejs-datepicker";
import draggable from "vuedraggable";
import EventBus from "@/event-bus.js";
import Editor from "@tinymce/tinymce-vue";
import VueLoadImage from "vue-load-image";
import modal from "../../credit-cards/modal.vue";
import pointCategorymodal from "../../credit-cards/add-point-cateogry-modal.vue";

import {
  validateIssuerName,
  validateUpgradeCard,
  validateCardName,
  validateProductChange,
  validateDowngradeCard,
  validateUploadPhoto,
  validateAnnualFee,
  validateNumeric,
  validateRules,
  validateFeeCategory,
  validateAlphaNumeric,
  validatePoints,
  validatePointsNames,
  validatePerks,
  validateGroupPoints,
  validateTargetedOffers,
} from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";
import Vue from "vue";
import Index from "../../accounts/index.vue";
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";

export default {
  data() {
    return {
      valuation: "",
      toggleColorList: false,

      calculatedFee: 0,
      cardDetails: {
        issuer: {
          name: "",
        },
        name: "",
        active_rules_check: "No",
        card_type: "credit",
        annual_fee: "",
        upgrade_card: "",
        product_change: "",
        downgrade_card: "",
        points_description: "",
        effective_fee_description: "",
        international_transaction: false,
        international_transaction_status: "no",
        five_twenty_four: true,
        photo: "",
        fee_categories: [],
        activeRules: [],
        points_categories: [],
        perks: [],
        targeted_offers: [],
        photo_array: [],
      },
      previewPicture: [],
      removedCardImages: [],
      SubCategorypoints: {
        show: false,

        name: "",
        category: "",
        order: "",
        subcategory: [
          {
            order: {
              type: Number,
            },

            category: "",
          },
        ],
      },
      removedSubcategories: [],
      indexes: [],
      points_categories_option: [],
      dynamic_bonus_categoires: [],
      perks_key_date_option: [
        {
          name: "Enrollment Date",
          value: "enrollment_date",
        },
        {
          name: "Calendar Year",
          value: "calendar_year",
        },
        {
          name: "Custom Date",
          value: "custom_date",
        },
        {
          name: "Anniversary Date",
          value: "anniversary_date",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      perks_date_type_option: [
        {
          name: "Expiration",
          value: "expiration",
        },
        {
          name: "Arrival",
          value: "arrival",
        },
        {
          name: "Deadline",
          value: "deadline",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      expiration_date_type_options: [
        {
          name: "Monthly",
          value: "monthly",
        },
        {
          name: "Custom Date",
          value: "custom_date",
        },
        {
          name: "Calendar Year",
          value: "calendar_year",
        },
        {
          name: "Anniversary Date",
          value: "anniversary_date",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      earned_perks_key_date_option: [
        {
          name: "Enrollment Date",
          value: "enrollment_date",
        },
        {
          name: "Calendar Year",
          value: "calendar_year",
        },
        {
          name: "Custom Date",
          value: "custom_date",
        },
        {
          name: "Anniversary Date",
          value: "anniversary_date",
        },
        {
          name: "Earned Date",
          value: "earned_date",
        },
        {
          name: "Elite Year January",
          value: "elite_year_january",
        },
        {
          name: "Elite Year February",
          value: "elite_year_february",
        },
        {
          name: "Elite Year March",
          value: "elite_year_march",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      perks_call_to_action_options: [
        {
          name: "Track usage",
          value: "track_usage",
        },
        {
          name: "Track earned status",
          value: "track_earned_status",
        },
        {
          name: "Mark as received",
          value: "mark_as_received",
        },
        {
          name: "Mark as enrolled",
          value: "mark_as_enrolled",
        },
        {
          name: "Track earned tiers",
          value: "track_earned_tiers",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      earned_perks_call_to_action_options: [
        {
          name: "Track usage",
          value: "track_usage",
        },

        {
          name: "Mark as received",
          value: "mark_as_received",
        },
        {
          name: "Mark as enrolled",
          value: "mark_as_enrolled",
        },
        {
          name: "Track earned tiers",
          value: "track_earned_tiers",
        },
        {
          name: "N/A",
          value: "NA",
        },
      ],

      issuersList: [],
      photoChangeFlag: false,

      rulesList: [],

      cardsList: [],
      toggleCardsList: false,

      userAddedBonusCategoryList: [],
      userAddedBonusCategoryToApprove: [],
      tempcontainer: "",
      AllApproved: false,
      showDeleteStatus: {
        msg: "",
        status: false,
      },
      userAddedCategory: {
        msg: "",
        status: false,
      },
      pointCategoryAddSelector: "",

      pointCategoryAddIndex: "",
      pointCategoryAddGroupIndex: "",
      pointCategoryAddType: "",

      pointCategoryAddTargetindex: "",
      pointCategoryAddTargetBonusindex: "",
      pointCategoryAddTargetCategoryIndex: "",

      errors: {
        issuerName: {
          msg: "",
          success: false,
        },
        upgradeCard: {
          msg: "",
          success: false,
        },
        cardName: {
          msg: "",
          success: false,
        },
        productChange: {
          msg: "",
          success: false,
        },
        downgradeCard: {
          msg: "",
          success: false,
        },
        photo: {
          msg: "",
          success: false,
        },
        annualFee: {
          msg: "",
          success: false,
        },
        rules: {
          msg: "",
          success: false,
        },
        feeCategory: {
          msg: "",
          success: false,
        },
        pointCategories: {
          msg: "",
          success: false,
        },
        perks: {
          msg: "",
          success: false,
        },
        perks1: {
          msg: "",
          success: false,
        },
        subCategory: {
          msg: "",
          success: false,
        },
        targetedOffers: {
          msg: "",
          success: false,
        },
      },
      validateIssuerName,
      validateUpgradeCard,
      validateCardName,
      validateProductChange,
      validateDowngradeCard,
      validateUploadPhoto,
      validateAnnualFee,
      validateNumeric,
      validateRules,
      validateFeeCategory,
      validateAlphaNumeric,
      validatePoints,
      validatePointsNames,
      validatePerks,
      validateGroupPoints,
      validateTargetedOffers,

      modifiedList: [],
      genericErrorMessage,
      toast,
      showModal: false,
      showModal1: false,
      bonusIndex: "",
      currentModelStatus: "",
      tempbonusCategory: [],
      BonusCategoryData: [],
      pointsCategoriesOptionList: [],
      newlyCreatedPointCategories: [],
      askPointCategoryRemove: {
        msg: "",
        success: false,
        cardPointCategoryIndex: "",
        cardPointCategoryGroupIndex: "",
        newPointCategoryIndex: "",
        removalType: "",
        cardTargetedOfferIndex: "",
        cardTargetedOfferBonusIndex: "",
        cardTargetedOfferCategoryIndex: "",
      },
    };
  },
  methods: {
    defaultImage(index) {
      // if (index > 0) {
      //   let tempcontainer = this.cardDetails.photo;
      //   this.cardDetails.photo = this.cardDetails.photo_array[index - 1];
      //   this.cardDetails.photo_array.splice(index - 1, 1);
      //   this.cardDetails.photo_array.push(tempcontainer);
      // }

      // let temp = this.previewPicture[index];
      // this.previewPicture.splice(index, 1);
      // this.previewPicture.unshift(temp);
      this.previewPicture.forEach((data) => {
        if (data.defaultImage) {
          data.defaultImage = false;
        }
      });
      this.previewPicture[index].defaultImage = true;
    },
    removeCardImage(picture, index) {
      if (index == 0) {
        if (this.cardDetails.photo_array.length > 0) {
          let wasDefault = false;
          if (this.previewPicture[index].defaultImage == true) {
            wasDefault = true;
          }
          if (!this.previewPicture[index].isEdited) {
            this.removedCardImages.push({
              from: "photo",
              src: this.cardDetails.photo,
            });
          }
          this.cardDetails.photo = "";
          this.previewPicture.splice(index, 1);
          this.cardDetails.photo = this.cardDetails.photo_array[0];
          this.cardDetails.photo_array.splice(0, 1);
          if (wasDefault == true) {
            this.previewPicture[0].defaultImage = true;
          }
        } else {
          if (!this.previewPicture[index].isEdited) {
            this.removedCardImages.push({
              from: "photo",
              src: this.cardDetails.photo,
            });
          }
          this.cardDetails.photo = "";
          this.previewPicture.splice(index, 1);
        }
      } else {
        if (!this.previewPicture[index].isEdited) {
          this.removedCardImages.push({
            from: "photoArray",
            src: this.cardDetails.photo_array[index - 1],
          });
        }
        this.cardDetails.photo_array.splice(index - 1, 1);
        let wasDefault = false;
        if (this.previewPicture[index].defaultImage == true) {
          wasDefault = true;
        }
        this.previewPicture.splice(index, 1);
        if (wasDefault == true) {
          this.previewPicture[0].defaultImage = true;
        }
      }
    },
    imageclicked(inp, baseUrl, picture) {
      let image = {
        src:
          picture.isEdited == true ? inp.toString() : baseUrl + inp.toString(),
      };
      const $viewer = viewerApi({
        options: {
          toolbar: true,
          navbar: false,
          title: false,
          initialViewIndex: 0,
          zIndex: 99999,
        },
        images: [image],
      });
    },
    removeDynamicBonusCategories(index) {
      if (this.cardDetails.points_categories.length > 0) {
        this.cardDetails.points_categories.forEach((pointCat) => {
          if (
            pointCat.dynamic_bonus_category &&
            pointCat.dynamic_bonus_category.length > 0
          ) {
            pointCat.dynamic_bonus_category.splice(index, 1);
          }
          if (pointCat.groupCategories && pointCat.groupCategories.length > 0) {
            pointCat.groupCategories.forEach((groupCat) => {
              if (groupCat.dynamic_bonus_category.length > 0) {
                groupCat.dynamic_bonus_category.splice(index, 1);
              }
            });
          }
        });
      }
      if (this.cardDetails.targeted_offers.length > 0) {
        this.cardDetails.targeted_offers.forEach((targetedoffer) => {
          if (
            targetedoffer.bonusCategory &&
            targetedoffer.bonusCategory.length > 0
          ) {
            targetedoffer.bonusCategory.forEach((bonusCategory) => {
              if (
                bonusCategory &&
                bonusCategory.categories &&
                bonusCategory.categories.length > 0
              ) {
                bonusCategory.categories.forEach((t_bonuscat) => {
                  if (t_bonuscat.dynamic_bonus_category.length > 0) {
                    t_bonuscat.dynamic_bonus_category.splice(index, 1);
                  }
                });
              }
            });
          }
        });
      }
    },
    changeIsAdded(index, DynamicindexCat) {
      // console.log(
      //   "in before",
      //   this.cardDetails.points_categories[index].dynamic_bonus_category[
      //     DynamicindexCat
      //   ].isAdded
      // );
      // console.log(
      //   "in addeddddd",
      //   this.cardDetails.points_categories[index].dynamic_bonus_category[
      //     DynamicindexCat
      //   ].isAdded
      // );
    },
    addDynamicBonusCategory() {
      this.dynamic_bonus_categoires.push({
        limit: 0,
      });
      this.addAllDynamicCategoriesCheckboxes();
    },
    addAllDynamicCategoriesCheckboxes() {
      if (this.dynamic_bonus_categoires.length > 0) {
        this.dynamic_bonus_categoires.forEach((main, index) => {
          if (this.cardDetails.points_categories.length > 0) {
            this.cardDetails.points_categories.forEach((data) => {
              if (data.dynamic_bonus_category.length <= index) {
                data.dynamic_bonus_category.push({
                  isAdded: false,
                });
              }
              if (data.groupCategories && data.groupCategories.length > 0) {
                data.groupCategories.forEach((groupCat) => {
                  if (groupCat.dynamic_bonus_category.length <= index) {
                    groupCat.dynamic_bonus_category.push({
                      isAdded: false,
                    });
                  }
                });
              }
            });
          }
          if (this.cardDetails.targeted_offers.length > 0) {
            this.cardDetails.targeted_offers.forEach((targetedoffer) => {
              if (
                targetedoffer.bonusCategory &&
                targetedoffer.bonusCategory.length > 0
              ) {
                targetedoffer.bonusCategory.forEach((bonusCategory) => {
                  if (
                    bonusCategory &&
                    bonusCategory.categories &&
                    bonusCategory.categories.length > 0
                  ) {
                    bonusCategory.categories.forEach((t_bonuscat) => {
                      if (t_bonuscat.dynamic_bonus_category.length <= index) {
                        t_bonuscat.dynamic_bonus_category.push({
                          isAdded: false,
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    },
    removeGroupItem(index) {
      //console.log(this.cardDetails.points_categories[index]);
      if (
        this.cardDetails.points_categories[index].points_category &&
        this.cardDetails.points_categories[index].points_category.trim() !=
          "" &&
        this.newlyCreatedPointCategories &&
        this.newlyCreatedPointCategories.length > 0
      ) {
        let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
          (a) =>
            a._id.toString() ==
            this.cardDetails.points_categories[index].points_category.toString()
        );
        if (ifNewPointCategory >= 0) {
          this.askPointCategoryRemove.msg =
            'Do you want to delete the newly created "' +
            this.newlyCreatedPointCategories[ifNewPointCategory].name +
            '" Point Category from database as well?';
          this.askPointCategoryRemove.success = true;
          this.askPointCategoryRemove.cardPointCategoryIndex = index;
          this.askPointCategoryRemove.newPointCategoryIndex =
            ifNewPointCategory;

          this.askPointCategoryRemove.removalType = "simple";
        } else {
          this.removeGroupedItemFirstIndex(index);
        }
      } else {
        this.removeGroupedItemFirstIndex(index);
      }
    },
    removeGroupedItemFirstIndex(index) {
      if (
        this.cardDetails.points_categories[index].groupCategories.length == 0
      ) {
        this.cardDetails.points_categories.splice(index, 1);
      } else {
        let tempCat =
          this.cardDetails.points_categories[index].groupCategories[0];
        this.cardDetails.points_categories[index].points_category =
          tempCat.points_category;
        this.cardDetails.points_categories[index].multiplier =
          tempCat.multiplier;
        this.cardDetails.points_categories[index].percentage =
          tempCat.percentage;

        this.cardDetails.points_categories[index].groupCategories.splice(0, 1);
      }
    },
    SetCategoriesDate(category, inp, index, inptype, Bonusindex) {
      if (inp == "calendar_year") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(0, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(11, 31);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q1") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(0, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(2, 31);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q2") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(3, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(5, 30);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q3") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(6, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(8, 30);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "q4") {
        category.beginningDate = new Date();
        category.beginningDate.setMonth(9, 1);
        category.beginningDate.setHours(0, 0, 0);

        category.endDate = new Date();
        category.endDate.setMonth(11, 31);
        category.endDate.setHours(23, 59, 59);
      } else if (inp == "anniversary_year") {
        // category.beginningDate = new Date();
        // // category.beginningDate.setDate(1);
        // category.beginningDate.setHours(0, 0, 0);
        category.beginningDate = "";
        category.endDate = "";
      } else if (inp == "recurring_monthly") {
        category.beginningDate = "";
        category.endDate = "";
      } else if (inp == "recurring_quarters") {
        category.beginningDate = "";
        category.endDate = "";
      }

      if (inptype == "point_categories") {
        let temp = this.cardDetails.points_categories[index];
        temp.manage_spend_limit_options = category;
        temp.manage_spend_limit_options.date_type = inp;

        Vue.set(this.cardDetails.points_categories, index, temp);
      }
      if (inptype == "targeted_offers") {
        let temp =
          this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex];
        temp.manage_spend_limit_options = category;
        temp.manage_spend_limit_options.date_type = inp;

        Vue.set(
          this.cardDetails.targeted_offers[index].bonusCategory,
          Bonusindex,
          temp
        );
      }
    },
    fixvalue(index, inptype, Bonusindex) {
      if (inptype == "point_categories") {
        let temp = this.cardDetails.points_categories[index];
        Vue.set(this.cardDetails.points_categories, index, temp);
      }
      if (inptype == "targeted_offers") {
        let temp =
          this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex];

        Vue.set(
          this.cardDetails.targeted_offers[index].bonusCategory,
          Bonusindex,
          temp
        );
      }
    },
    async addTargetedOfferCategory(index, Bonusindex) {
      if (
        (await this.hasTargetedOfferCategoryUniqueNames(
          this.cardDetails.targeted_offers[index].bonusCategory
        )) != true
      ) {
        this.errors.targetedOffers.msg = "Target Offer field must be unique";
        this.errors.targetedOffers.success = true;
        return;
      }

      await this.validateTargetedOffers(
        this.cardDetails.targeted_offers[index].bonusCategory,
        "targetedOffers"
      );
      let { targetedOffers } = this.errors;
      if (targetedOffers.success) {
        return false;
      }
      this.cardDetails.targeted_offers[index].bonusCategory[
        Bonusindex
      ].categories.push({
        points_category: "",
        percentage: "",
        multiplier: 0,
        dynamic_bonus_category: [],
      });
      this.addAllDynamicCategoriesCheckboxes();
    },
    removeTargetedOfferCategory(index, Bonusindex, categoryIndex) {
      if (
        this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
          .categories.length > 1
      ) {
        if (
          this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
            .categories[categoryIndex].points_category &&
          this.cardDetails.targeted_offers[index].bonusCategory[
            Bonusindex
          ].categories[categoryIndex].points_category.trim() != "" &&
          this.newlyCreatedPointCategories &&
          this.newlyCreatedPointCategories.length > 0
        ) {
          let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
            (a) =>
              a._id.toString() ==
              this.cardDetails.targeted_offers[index].bonusCategory[
                Bonusindex
              ].categories[categoryIndex].points_category.toString()
          );
          if (ifNewPointCategory >= 0) {
            this.askPointCategoryRemove.msg =
              'Do you want to delete the newly created "' +
              this.newlyCreatedPointCategories[ifNewPointCategory].name +
              '" Point Category from database as well?';
            this.askPointCategoryRemove.success = true;

            this.askPointCategoryRemove.cardTargetedOfferIndex = index;
            this.askPointCategoryRemove.cardTargetedOfferBonusIndex =
              Bonusindex;
            this.askPointCategoryRemove.cardTargetedOfferCategoryIndex =
              categoryIndex;

            this.askPointCategoryRemove.newPointCategoryIndex =
              ifNewPointCategory;
            this.askPointCategoryRemove.removalType = "targeted_group";
          } else {
            this.cardDetails.targeted_offers[index].bonusCategory[
              Bonusindex
            ].categories.splice(categoryIndex, 1);
          }
        } else {
          this.cardDetails.targeted_offers[index].bonusCategory[
            Bonusindex
          ].categories.splice(categoryIndex, 1);
        }
      } else if (
        this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
          .categories.length == 1
      ) {
        if (
          this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
            .categories[0].points_category &&
          this.cardDetails.targeted_offers[index].bonusCategory[
            Bonusindex
          ].categories[0].points_category.trim() != "" &&
          this.newlyCreatedPointCategories &&
          this.newlyCreatedPointCategories.length > 0
        ) {
          let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
            (a) =>
              a._id.toString() ==
              this.cardDetails.targeted_offers[index].bonusCategory[
                Bonusindex
              ].categories[0].points_category.toString()
          );
          if (ifNewPointCategory >= 0) {
            this.askPointCategoryRemove.msg =
              'Do you want to delete the newly created "' +
              this.newlyCreatedPointCategories[ifNewPointCategory].name +
              '" Point Category from database as well?';
            this.askPointCategoryRemove.success = true;
            this.askPointCategoryRemove.cardTargetedOfferIndex = index;
            this.askPointCategoryRemove.cardTargetedOfferBonusIndex =
              Bonusindex;
            this.askPointCategoryRemove.newPointCategoryIndex =
              ifNewPointCategory;
            this.askPointCategoryRemove.removalType = "targeted_single";
          } else {
            this.cardDetails.targeted_offers[index].bonusCategory.splice(
              Bonusindex,
              1
            );
          }
        } else {
          this.cardDetails.targeted_offers[index].bonusCategory.splice(
            Bonusindex,
            1
          );
        }
        // console.log(
        //   "2",
        //   this.cardDetails.targeted_offers[index].bonusCategory[Bonusindex]
        // );
      }
    },
    targetedofferchangehandler(inp) {
      this.updateAllTargetedlimitCategories();
    },
    validateMainTargetedOffer() {
      if (this.cardDetails.targeted_offers.length > 0) {
        let check = 0;
        this.cardDetails.targeted_offers.forEach((data) => {
          if (data.bonusCategory && data.bonusCategory.length == 0) {
            check = 1;
            return false;
          }
        });
        if (check == 1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    updateAllTargetedlimitCategories() {
      for (var i = 0; i < this.cardDetails.targeted_offers.length; i++) {
        if (this.cardDetails.targeted_offers[i].manage_spend_limit == true) {
          if (
            this.cardDetails.targeted_offers[i].manage_spend_limit_options
              .apply_spend_limit_to_other_categories == "true"
          ) {
            this.handleTargetCategoryinLimit(i);
          }
        }
      }
    },
    async addTargetedOfferBonusCategory(index, inpType) {
      if (this.cardDetails.targeted_offers.length > 0) {
        if (
          (await this.hasTargetedOfferCategoryUniqueNames(
            this.cardDetails.targeted_offers[index].bonusCategory
          )) != true
        ) {
          this.errors.targetedOffers.msg = "Target Offer field must be unique";
          this.errors.targetedOffers.success = true;
          return;
        }

        await this.validateTargetedOffers(
          this.cardDetails.targeted_offers[index].bonusCategory,
          "targetedOffers"
        );
        let { targetedOffers } = this.errors;
        if (targetedOffers.success) {
          return false;
        }
        this.cardDetails.targeted_offers[index].bonusCategory.push({
          categories: [
            {
              points_category: "",
              percentage: "",
              multiplier: 0,
              dynamic_bonus_category: [],
            },
          ],
          manage_spend_limit: false,
          manage_spend_limit_options: {
            spend_limit: "",
            points_limit: 0,
            beginningDate: "",
            endDate: "",
            date_type: "",
            // apply_spend_limit_to_other_categories: false,
            // categories_in_limit: [
            //   {
            //     category: "",
            //     name: "",
            //     category_in_limit: false,
            //   },
            // ],
          },
          category_type: inpType,
          creator_offset: new Date().getTimezoneOffset(),
        });
        this.addAllDynamicCategoriesCheckboxes();
      }
    },

    async addMainTargetedOffer() {
      if ((await this.validateMainTargetedOffer()) != true) {
        this.errors.targetedOffers.msg =
          "Targeted Offers field cannot be empty";
        this.errors.targetedOffers.success = true;
        return;
      }
      this.cardDetails.targeted_offers.push({
        bonusCategory: [],
      });
    },
    async hasTargetedOfferCategoryUniqueNames(inp, categoryType) {
      var tmpArr = [];
      for (var i = 0; i < inp.length; i++) {
        var tempArrGroup = [];
        if (inp[i].category_type == "single") {
          if (inp[i].categories && inp[i].categories.length > 0) {
            for (var j = 0; j < inp[i].categories.length; j++) {
              if (tmpArr.indexOf(inp[i].categories[j].points_category) < 0) {
                tmpArr.push(inp[i].categories[j].points_category);
              } else {
                // this.error.duplicateIndices.push(i);
                return false;
              }
            }
          }
        }
        if (inp[i].category_type == "group") {
          if (inp[i].categories && inp[i].categories.length > 0) {
            for (var j = 0; j < inp[i].categories.length; j++) {
              if (
                tempArrGroup.indexOf(inp[i].categories[j].points_category) < 0
              ) {
                tempArrGroup.push(inp[i].categories[j].points_category);
              } else {
                // this.error.duplicateIndices.push(i);
                return false;
              }
            }
          }
        }
      }
      return true;
    },
    async finalTargetedValidation(index) {
      let check = 0;
      if (
        (await this.hasTargetedOfferCategoryUniqueNames(
          this.cardDetails.targeted_offers[index].bonusCategory
        )) != true
      ) {
        this.errors.targetedOffers.msg = "Target Offer field must be unique";
        this.errors.targetedOffers.success = true;
        check = 1;
        //return false;
      }
      if (check == 0) {
        await this.validateTargetedOffers(
          this.cardDetails.targeted_offers[index].bonusCategory,
          "targetedOffers"
        );
        let { targetedOffers } = this.errors;
        if (targetedOffers.success) {
          check = 1;
          //return false;
        }
      }
      if (check == 1) {
        return false;
      } else {
        return true;
      }
    },
    showBonusCategoryModel(index, inp) {
      this.bonusIndex = index;
      this.currentModelStatus = inp;
      if (inp == "fee") {
        this.BonusCategoryData = this.cardDetails.fee_categories;
        this.tempbonusCategory =
          this.cardDetails.fee_categories[index].bonus_categories.slice();
      } else if (inp == "perks") {
        this.BonusCategoryData = this.cardDetails.perks;
        this.tempbonusCategory =
          this.cardDetails.perks[index].bonus_categories.slice();
      }
      this.showModal = true;
    },
    showPointCategryModal(categoryType, index, index2) {
      this.pointCategoryAddIndex = index;
      this.pointCategoryAddGroupIndex = index2;
      this.pointCategoryAddType = categoryType;
      this.pointsCategoriesOptionList = this.points_categories_option;
      this.pointCategoryAddSelector = "pointDetails";
      this.showModal1 = true;
    },
    showPointCategryModalForTargetedOffer(index, Bonusindex, categoryIndex) {
      this.pointCategoryAddTargetindex = index;
      this.pointCategoryAddTargetBonusindex = Bonusindex;
      this.pointCategoryAddTargetCategoryIndex = categoryIndex;
      this.pointCategoryAddSelector = "targetedOffer";
      this.showModal1 = true;
    },
    closeModalonSuccess1(pointsCategorylist, newpointscategoryName) {
      this.showModal1 = false;
      this.points_categories_option = pointsCategorylist;
      let tempCategoryIndex = this.points_categories_option.findIndex(
        (a) => a.name && a.name.toString() == newpointscategoryName.toString()
      );
      if (tempCategoryIndex >= 0) {
        this.newlyCreatedPointCategories.push(
          this.points_categories_option[tempCategoryIndex]
        );
        if (this.pointCategoryAddSelector == "pointDetails") {
          if (this.pointCategoryAddType == "single") {
            this.cardDetails.points_categories[
              this.pointCategoryAddIndex
            ].points_category =
              this.points_categories_option[tempCategoryIndex]._id;
            this.categorychangeHandler(this.pointCategoryAddIndex);
          } else if (this.pointCategoryAddType == "group") {
            this.cardDetails.points_categories[
              this.pointCategoryAddIndex
            ].groupCategories[this.pointCategoryAddGroupIndex].points_category =
              this.points_categories_option[tempCategoryIndex]._id;
          }
        } else if ((this.pointCategoryAddSelector = "targetedOffer")) {
          this.cardDetails.targeted_offers[
            this.pointCategoryAddTargetindex
          ].bonusCategory[this.pointCategoryAddTargetBonusindex].categories[
            this.pointCategoryAddTargetCategoryIndex
          ].points_category =
            this.points_categories_option[tempCategoryIndex]._id;
          this.targetedofferchangehandler(
            this.pointCategoryAddTargetBonusindex
          );
        }
      }
    },
    removeSingleitemPointCategory(index) {
      //console.log(this.cardDetails.points_categories[index]);
      if (
        this.cardDetails.points_categories[index].points_category &&
        this.cardDetails.points_categories[index].points_category.trim() !=
          "" &&
        this.newlyCreatedPointCategories &&
        this.newlyCreatedPointCategories.length > 0
      ) {
        let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
          (a) =>
            a._id.toString() ==
            this.cardDetails.points_categories[index].points_category.toString()
        );
        if (ifNewPointCategory >= 0) {
          this.askPointCategoryRemove.msg =
            'Do you want to delete the newly created "' +
            this.newlyCreatedPointCategories[ifNewPointCategory].name +
            '" Point Category from database as well?';
          this.askPointCategoryRemove.success = true;
          this.askPointCategoryRemove.cardPointCategoryIndex = index;
          this.askPointCategoryRemove.newPointCategoryIndex =
            ifNewPointCategory;
          this.askPointCategoryRemove.removalType = "simple";
        } else {
          this.cardDetails.points_categories.splice(index, 1);
        }
      } else {
        this.cardDetails.points_categories.splice(index, 1);
      }
    },
    removeNewPointCategory() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve, reject) => {
        this.$axios
          .post(
            this.$ApiKeys.BASE_URL + this.$EndPoints.UpdateCategories,
            {
              remove_categories: [
                this.newlyCreatedPointCategories[
                  this.askPointCategoryRemove.newPointCategoryIndex
                ]._id,
              ],
              isAdded: false,
            },
            {
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            }
          )
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              this.updateStatus = {
                msg: res.data.data,
                status: true,
              };
              //resolve(this.getCategories());
              let orignalPointIndex = this.points_categories_option.findIndex(
                (a) =>
                  a._id.toString() ==
                  this.newlyCreatedPointCategories[
                    this.askPointCategoryRemove.newPointCategoryIndex
                  ]._id.toString()
              );
              if (orignalPointIndex >= 0) {
                this.points_categories_option.splice(orignalPointIndex, 1);
              }
              this.newlyCreatedPointCategories.splice(
                this.askPointCategoryRemove.newPointCategoryIndex,
                1
              );
              // this.cardDetails.points_categories.splice(
              //   this.askPointCategoryRemove.cardPointCategoryIndex,
              //   1
              // );
              if (this.askPointCategoryRemove.removalType == "simple") {
                this.removeGroupedItemFirstIndex(
                  this.askPointCategoryRemove.cardPointCategoryIndex
                );
              } else if (this.askPointCategoryRemove.removalType == "group") {
                this.cardDetails.points_categories[
                  this.askPointCategoryRemove.cardPointCategoryIndex
                ].groupCategories.splice(
                  this.askPointCategoryRemove.cardPointCategoryGroupIndex,
                  1
                );
              } else if (
                this.askPointCategoryRemove.removalType == "targeted_group"
              ) {
                this.cardDetails.targeted_offers[
                  this.askPointCategoryRemove.cardTargetedOfferIndex
                ].bonusCategory[
                  this.askPointCategoryRemove.cardTargetedOfferBonusIndex
                ].categories.splice(
                  this.askPointCategoryRemove.cardTargetedOfferCategoryIndex,
                  1
                );
              } else if (
                this.askPointCategoryRemove.removalType == "targeted_single"
              ) {
                this.cardDetails.targeted_offers[
                  this.askPointCategoryRemove.cardTargetedOfferIndex
                ].bonusCategory.splice(
                  this.askPointCategoryRemove.cardTargetedOfferBonusIndex,
                  1
                );
              }

              this.askPointCategoryRemove.success = false;
              this.askPointCategoryRemove.cardPointCategoryIndex = "";
              this.askPointCategoryRemove.newPointCategoryIndex = "";
              this.askPointCategoryRemove.cardPointCategoryGroupIndex = "";
              this.askPointCategoryRemove.removalType = "";
              this.askPointCategoryRemove.cardTargetedOfferIndex = "";
              this.askPointCategoryRemove.cardTargetedOfferBonusIndex = "";
              this.askPointCategoryRemove.cardTargetedOfferCategoryIndex = "";
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.toast(this.genericErrorMessage());

            this.$vs.loading.close();
            // console.log("Error in updateCategories: ",e);
          });
      });
    },
    keepNewPointCategory() {
      // this.cardDetails.points_categories.splice(
      //   this.askPointCategoryRemove.cardPointCategoryIndex,
      //   1
      // );
      if (this.askPointCategoryRemove.removalType == "simple") {
        this.removeGroupedItemFirstIndex(
          this.askPointCategoryRemove.cardPointCategoryIndex
        );
      } else if (this.askPointCategoryRemove.removalType == "group") {
        this.cardDetails.points_categories[
          this.askPointCategoryRemove.cardPointCategoryIndex
        ].groupCategories.splice(
          this.askPointCategoryRemove.cardPointCategoryGroupIndex,
          1
        );
      } else if (this.askPointCategoryRemove.removalType == "targeted_group") {
        this.cardDetails.targeted_offers[
          this.askPointCategoryRemove.cardTargetedOfferIndex
        ].bonusCategory[
          this.askPointCategoryRemove.cardTargetedOfferBonusIndex
        ].categories.splice(
          this.askPointCategoryRemove.cardTargetedOfferCategoryIndex,
          1
        );
      } else if (this.askPointCategoryRemove.removalType == "targeted_single") {
        this.cardDetails.targeted_offers[
          this.askPointCategoryRemove.cardTargetedOfferIndex
        ].bonusCategory.splice(
          this.askPointCategoryRemove.cardTargetedOfferBonusIndex,
          1
        );
      }

      this.askPointCategoryRemove.success = false;
      this.askPointCategoryRemove.cardPointCategoryIndex = "";
      this.askPointCategoryRemove.newPointCategoryIndex = "";
      this.askPointCategoryRemove.cardPointCategoryGroupIndex = "";
      this.askPointCategoryRemove.removalType = "";
      this.askPointCategoryRemove.cardTargetedOfferIndex = "";
      this.askPointCategoryRemove.cardTargetedOfferBonusIndex = "";
      this.askPointCategoryRemove.cardTargetedOfferCategoryIndex = "";
    },

    removeGroupPointsCategory(index, Groupindex) {
      if (
        this.cardDetails.points_categories[index].groupCategories[Groupindex]
          .points_category &&
        this.cardDetails.points_categories[index].groupCategories[
          Groupindex
        ].points_category.trim() != "" &&
        this.newlyCreatedPointCategories &&
        this.newlyCreatedPointCategories.length > 0
      ) {
        let ifNewPointCategory = this.newlyCreatedPointCategories.findIndex(
          (a) =>
            a._id.toString() ==
            this.cardDetails.points_categories[index].groupCategories[
              Groupindex
            ].points_category.toString()
        );
        if (ifNewPointCategory >= 0) {
          this.askPointCategoryRemove.msg =
            'Do you want to delete the newly created "' +
            this.newlyCreatedPointCategories[ifNewPointCategory].name +
            '" Point Category from database as well?';
          this.askPointCategoryRemove.success = true;
          this.askPointCategoryRemove.cardPointCategoryIndex = index;
          this.askPointCategoryRemove.cardPointCategoryGroupIndex = Groupindex;
          this.askPointCategoryRemove.newPointCategoryIndex =
            ifNewPointCategory;
          this.askPointCategoryRemove.removalType = "group";
        } else {
          this.cardDetails.points_categories[index].groupCategories.splice(
            Groupindex,
            1
          );
        }
      } else {
        this.cardDetails.points_categories[index].groupCategories.splice(
          Groupindex,
          1
        );
      }
    },

    closeModalonDismiss1() {
      this.showModal1 = false;
    },
    closeModalonSuccess() {
      this.showModal = false;
    },
    closeModalonDismiss() {
      if (this.currentModelStatus == "fee") {
        this.cardDetails.fee_categories[this.bonusIndex].bonus_categories =
          this.tempbonusCategory;
      } else if (this.currentModelStatus == "perks") {
        this.cardDetails.perks[this.bonusIndex].bonus_categories =
          this.tempbonusCategory;
      }
      this.showModal = false;
    },
    temphandler() {
      this.cardDetails.perks.push({ show: false });
      this.cardDetails.perks.pop();
    },

    removePerk(index) {
      if (
        this.cardDetails.perks[index].token &&
        this.cardDetails.perks[index].token != ""
      ) {
        let tempInd = this.cardDetails.perks.findIndex(
          (a) =>
            a.earned_status.earned_perk_token ==
            this.cardDetails.perks[index].token
        );
        if (tempInd >= 0) {
          this.cardDetails.perks[tempInd].earned_status.earned_perk_token = "";
          this.cardDetails.perks[tempInd].earned_status.add_new_perk = false;
        }
      } else if (
        this.cardDetails.perks[index].earned_status.earned_perk_token &&
        this.cardDetails.perks[index].earned_status.earned_perk_token != ""
      ) {
        let temp1 = this.cardDetails.perks.findIndex(
          (a) =>
            a.token ==
            this.cardDetails.perks[index].earned_status.earned_perk_token
        );
        if (temp1 >= 0) {
          this.cardDetails.perks.splice(temp1, 1);
        }
      }
      this.cardDetails.perks.splice(index, 1);
    },
    handleEarnedCategory(val, index) {
      if (val) {
        let temp = val[index];
        temp.category = val[index].category;
        Vue.set(val, index, temp);
      }
    },
    scrollToTop() {
      // window.scrollTo(0,0);
      window.scrollTo({
        top: 200,
        // left: 0,
        behavior: "smooth",
      });
    },
    scrollToMid() {
      window.scrollTo({
        top: 650,
        behavior: "smooth",
      });
    },
    AddnewPerkhandler(index) {
      if (this.cardDetails.perks[index].earned_status.add_new_perk) {
        if (
          this.cardDetails.perks[index].earned_status.earned_perk_token &&
          this.cardDetails.perks[index].earned_status.earned_perk_token != ""
        ) {
          let temp1 = this.cardDetails.perks.findIndex(
            (a) =>
              a.token ==
              this.cardDetails.perks[index].earned_status.earned_perk_token
          );
          if (temp1 >= 0) {
            this.cardDetails.perks[temp1].disable = true;
          }
        }
      } else {
        if (
          this.cardDetails.perks[index].earned_status.earned_perk_token &&
          this.cardDetails.perks[index].earned_status.earned_perk_token != ""
        ) {
          let temp1 = this.cardDetails.perks.findIndex(
            (a) =>
              a.token ==
              this.cardDetails.perks[index].earned_status.earned_perk_token
          );
          if (temp1 >= 0) {
            this.cardDetails.perks[temp1].disable = false;
          }
        }
      }
    },
    CallToActionButton(index) {
      if (
        this.cardDetails.perks[index].call_to_action == "track_earned_status" &&
        this.cardDetails.perks[index].earned_status.earned_perk_token == ""
      ) {
        this.addEarnedPerk(index);
      } else if (
        this.cardDetails.perks[index].call_to_action == "track_earned_status" &&
        this.cardDetails.perks[index].earned_status.earned_perk_token != ""
      ) {
        let tempVAR = this.cardDetails.perks.findIndex(
          (a) =>
            a.token ==
            this.cardDetails.perks[index].earned_status.earned_perk_token
        );
        if (tempVAR >= 0) {
          this.cardDetails.perks[tempVAR].show = true;
        }
      } else if (
        this.cardDetails.perks[index].call_to_action != "track_earned_status" &&
        this.cardDetails.perks[index].earned_status.earned_perk_token != ""
      ) {
        let tempVAR = this.cardDetails.perks.findIndex(
          (a) =>
            a.token ==
            this.cardDetails.perks[index].earned_status.earned_perk_token
        );
        if (tempVAR >= 0) {
          this.cardDetails.perks[tempVAR].show = false;
        }
      }
    },
    updateInternationalTransaction(value) {
      this.cardDetails.international_transaction_status = value;
    },
    addCreditCustomDate(index) {
      if (this.cardDetails.fee_categories[index].custom_dates) {
        this.cardDetails.fee_categories[index].custom_dates.push("");
      } else {
        this.cardDetails.fee_categories[index].custom_dates = [""];
      }
    },
    onChangePerkKeyDateAddition(e, index) {
      let temp = this.cardDetails.perks[index];
      temp.key_date_addition = {
        weeks: this.cardDetails.perks[index].key_date_addition.weeks,
        months: this.cardDetails.perks[index].key_date_addition.months,
        years: this.cardDetails.perks[index].key_date_addition.years,
      };
      Vue.set(this.cardDetails.perks, index, temp);
    },
    onChangeCreditExpiry(e, index) {
      let temp = this.cardDetails.fee_categories[index];
      temp.expiration_date_addition = {
        weeks:
          this.cardDetails.fee_categories[index].expiration_date_addition.weeks,
        months:
          this.cardDetails.fee_categories[index].expiration_date_addition
            .months,
        years:
          this.cardDetails.fee_categories[index].expiration_date_addition.years,
      };
      Vue.set(this.cardDetails.fee_categories, index, temp);
    },
    setCreditCutoffNA(index) {
      if (
        this.cardDetails.fee_categories &&
        this.cardDetails.fee_categories[index]
      ) {
        let temp = this.cardDetails.fee_categories[index];
        temp.na_cutoff = !this.cardDetails.fee_categories[index].na_cutoff;
        Vue.set(this.cardDetails.fee_categories, index, temp);
      }
    },
    setPerkEstimatedNA(index) {
      if (this.cardDetails.perks && this.cardDetails.perks[index]) {
        let temp = this.cardDetails.perks[index];
        temp.na_estimated_val = !this.cardDetails.perks[index].na_estimated_val;
        Vue.set(this.cardDetails.perks, index, temp);
      }
    },
    setearnedPerkEstimatedNA(val, index) {
      if (val) {
        let temp = val[index];
        temp.na_estimated_val = !val[index].na_estimated_val;
        Vue.set(val, index, temp);
      }
    },
    setPerkDisplay(index) {
      if (this.cardDetails.perks && this.cardDetails.perks[index]) {
        this.cardDetails.perks[index].hide_on_dashboard =
          !this.cardDetails.perks[index].hide_on_dashboard;
      }
    },
    setPerkExpiration(index) {
      if (this.cardDetails.perks && this.cardDetails.perks[index]) {
        this.cardDetails.perks[index].no_first_year_expiration =
          !this.cardDetails.perks[index].no_first_year_expiration;
      }
    },
    onKeyDateChanged(val, index) {
      if (val == "NA") {
        this.cardDetails.perks[index].date_type = "NA";
      }
    },
    calculatePercentages() {
      this.cardDetails.points_categories.forEach((value, index) => {
        if (value.multiplier > 0) {
          this.cardDetails.points_categories[index].percentage =
            value.multiplier * this.valuation;
        } else {
          this.cardDetails.points_categories[index].percentage = "";
        }
      });
    },

    async addPointCategory(categoryType) {
      if (this.cardDetails.points_categories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.cardDetails.points_categories,
            "single"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }

        if (
          (await this.hasCategoryUniqueNamesGroup(
            this.cardDetails.points_categories,
            "group"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories Group field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }
      }

      await this.validatePointsNames(
        this.cardDetails.points_categories,
        "pointCategories"
      );
      await this.validatePoints(
        this.cardDetails.points_categories,
        "pointCategories"
      );
      let { pointCategories } = this.errors;
      if (pointCategories.success) {
        return false;
      }

      await this.cardDetails.points_categories.push({
        points_category: "",
        percentage: "",
        multiplier: 0,
        parentCategoryId: "",
        useredit: false,
        subCategories: [
          {
            order: {
              type: Number,
            },

            category: "",
          },
        ],
        removed_subCategories: [
          {
            category: "",
          },
        ],
        dynamic_bonus_category: [],
        manage_spend_limit: false,
        groupCategories: [],
        type: categoryType,
        manage_spend_limit_options: {
          spend_limit: 0,
          points_limit: 0,
          beginningDate: "",
          endDate: "",
          date_type: "",
          apply_spend_limit_to_other_categories: false,
        },
        creator_offset: new Date().getTimezoneOffset(),
      });
      this.addAllDynamicCategoriesCheckboxes();
    },

    async addPointCategoryGroupCategory(index) {
      if (
        (await this.hasCategoryUniqueNamesGroup(
          this.cardDetails.points_categories,
          "group"
        )) != true
      ) {
        this.errors.pointCategories.msg =
          "Point Categories Group field must be unique";
        this.errors.pointCategories.success = true;
        return;
      }
      await this.validateGroupPoints(
        this.cardDetails.points_categories,
        "pointCategories"
      );
      let { pointCategories } = this.errors;
      if (pointCategories.success) {
        return false;
      }

      this.cardDetails.points_categories[index].groupCategories.push({
        points_category: "",
        percentage: "",
        multiplier: 0,
        dynamic_bonus_category: [],
      });
      this.addAllDynamicCategoriesCheckboxes();
    },
    addNewCredit() {
      this.cardDetails.fee_categories.push({
        credit_title: "",
        amount: 0,
        description: "",
        per_use_amount: 0,
        na_cutoff: false,
        cutoff_date: "",
        expiration_date_type: "NA",
        custom_dates: [""],
        expiration_date_addition: {
          weeks: 0,
          months: 0,
          years: 0,
        },
        bonus_categories: [],
      });
    },
    async addPerk() {
      await this.cardDetails.perks.push({
        category: "",
        description: "",
        estimated_value: "",
        na_estimated_val: false,
        key_date: "NA",
        date_type: "NA",
        custom_dates: [""],
        hide_on_dashboard: false,
        no_first_year_expiration: false,
        key_date_addition: {
          weeks: 0,
          months: 0,
          years: 0,
        },
        call_to_action: "NA",

        track_usage: {
          option_value: "",
          multiple_use_limit: 0,
        },
        mark_as_enrolled: {
          option_value: "",
          master_cutoff_date: "",
          track_usage_type: "",
          multiple_use_limit: 0,
        },
        track_earned_tiers: {
          option_value: "",
          input_text: "",
          number_of_limit: 0,
        },
        earned_status: {
          earned_perk_token: "",
          add_new_perk: false,
        },
        show: true,
        bonus_categories: [],
      });
    },
    generate_token(length) {
      //edit the token allowed characters
      var a =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split(
          ""
        );
      var b = [];
      for (var i = 0; i < length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      return b.join("");
    },
    async addEarnedPerk(index) {
      var tempPerk = [];
      if (this.cardDetails.perks[index].earned_status.earned_perk_token == "") {
        let temp = this.generate_token(14);
        this.cardDetails.perks[index].earned_status.earned_perk_token = temp;
        if (this.cardDetails.perks.length - index == 1) {
          await this.cardDetails.perks.push({
            token: temp,
            category: "",
            description: "",
            estimated_value: "",
            na_estimated_val: false,
            key_date: "NA",
            date_type: "NA",
            custom_dates: [""],
            hide_on_dashboard: false,
            no_first_year_expiration: false,
            key_date_addition: {
              weeks: 0,
              months: 0,
              years: 0,
            },

            call_to_action: "NA",

            track_usage: {
              option_value: "",
              multiple_use_limit: 0,
            },
            mark_as_enrolled: {
              option_value: "",
              master_cutoff_date: "",
              track_usage_type: "single_use_one_time",
              multiple_use_limit: 0,
            },
            track_earned_tiers: {
              option_value: "",
              input_text: "",
              number_of_limit: 0,
            },
            earned_status: {
              earned_perk_token: "",
              add_new_perk: false,
            },
            show: true,
            disable: false,
            bonus_categories: [],
          });
        } else {
          await this.cardDetails.perks.splice(index + 1, 0, {
            token: temp,
            category: "",
            description: "",
            estimated_value: "",
            na_estimated_val: false,
            key_date: "NA",
            date_type: "NA",
            custom_dates: [""],
            hide_on_dashboard: false,
            no_first_year_expiration: false,
            key_date_addition: {
              weeks: 0,
              months: 0,
              years: 0,
            },

            call_to_action: "NA",

            track_usage: {
              option_value: "",
              multiple_use_limit: 0,
            },
            mark_as_enrolled: {
              option_value: "",
              master_cutoff_date: "",
              track_usage_type: "single_use_one_time",
              multiple_use_limit: 0,
            },
            track_earned_tiers: {
              option_value: "",
              input_text: "",
              number_of_limit: 0,
            },
            earned_status: {
              earned_perk_token: "",
              add_new_perk: false,
            },
            show: true,
            disable: false,
            bonus_categories: [],
          });
        }
        tempPerk.push();
      }
    },
    calculateRulesWidth() {
      this.modifiedList = [];
      let maxLength = 80;
      for (var i = 0; i < this.rulesList.length; i++) {
        this.modifiedList[i] = {
          rule: "",
          _id: "",
        };
        if (this.rulesList[i].rule.length > maxLength) {
          this.modifiedList[i] = {
            rule: this.rulesList[i].rule.substr(0, maxLength) + "...",
            _id: this.rulesList[i]._id,
          };
        } else {
          this.modifiedList[i] = {
            rule: this.rulesList[i].rule,
            _id: this.rulesList[i]._id,
          };
        }
      }
    },
    handleCardFilter() {
      this.toggleCardsList = true;
    },
    closeCardsList() {
      this.toggleCardsList = false;
      // this.getCardsList();
    },
    handleFilter() {
      this.toggleColorList = true;
    },

    closeColorList() {
      if (this.toggleColorList) {
        this.toggleColorList = false;
        this.getCardsList();
        this.getRules();
      }
    },
    async beforeFirstTabChange() {
      await this.validateIssuerName(
        this.cardDetails.issuer.name ? this.cardDetails.issuer.name : ""
      );
      await this.validateCardName(
        this.cardDetails.name ? this.cardDetails.name : ""
      );
      let { issuerName, cardName, photo } = this.errors;
      if (issuerName.success || cardName.success || photo.success) {
        return false;
      }
      this.errors.rules = {
        msg: "",
        success: false,
      };
      return true;
    },
    async beforeSecondTabChange() {
      await this.validateAnnualFee(this.cardDetails.annual_fee);
      await this.validateFeeCategory(this.cardDetails.fee_categories);
      let { annualFee, feeCategory } = this.errors;
      if (annualFee.success || feeCategory.success) {
        this.scrollToTop();
        return false;
      }
      return true;
    },
    async beforeThirdTabChange() {
      if (this.cardDetails.points_categories.length > 0) {
        if (
          (await this.hasCategoryUniqueNames(
            this.cardDetails.points_categories,
            "single"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }

        if (
          (await this.hasCategoryUniqueNamesGroup(
            this.cardDetails.points_categories,
            "group"
          )) != true
        ) {
          this.errors.pointCategories.msg =
            "Point Categories Group field must be unique";
          this.errors.pointCategories.success = true;
          return;
        }

        await this.validatePoints(
          this.cardDetails.points_categories,
          "pointCategories"
        );
        await this.validateGroupPoints(
          this.cardDetails.points_categories,
          "pointCategories"
        );
        let { pointCategories } = this.errors;
        if (pointCategories.success) {
          return false;
        }
        //console.log(this.cardDetails.points_categories);
        //return true;
      }
      if (this.cardDetails.targeted_offers.length > 0) {
        if ((await this.validateMainTargetedOffer()) != true) {
          this.errors.targetedOffers.msg =
            "Targeted Offers field cannot be empty";
          this.errors.targetedOffers.success = true;
          return false;
        }
        let temp = 0;
        let index = 0;
        for await (var i of this.cardDetails.targeted_offers) {
          if ((await this.finalTargetedValidation(index)) != true) {
            temp = 1;
            //return false;
          }
          index++;
        }
        if (temp == 1) {
          return false;
        } else {
          return true;
        }
      }
      return true;
    },
    async beforePerksTabChange() {
      await this.validatePerks(this.cardDetails.perks, "perks");
      let { perks } = this.errors;
      if (perks.success) {
        this.scrollToTop();
        return false;
      }

      return true;
    },

    removePointCategory(index) {
      this.cardDetails.points_categories.splice(index, 1);
    },
    removeCategoryItem(index) {
      this.cardDetails.fee_categories.splice(index, 1);
      this.calculateEffectiveFee();
    },
    calculateEffectiveFee() {
      let result = 0;
      for (var i = 0; i < this.cardDetails.fee_categories.length; i++) {
        result += Number(this.cardDetails.fee_categories[i].amount);
      }
      // if(result >= this.cardDetails.annual_fee){
      //     this.calculatedFee = 0;
      // } else {
      this.calculatedFee = this.cardDetails.annual_fee - result;
      // }
      this.validateAnnualFee(this.cardDetails.annual_fee);
    },

    addNewRule() {
      this.cardDetails.activeRules.push({ effectiveDate: "", rule: "" });
    },
    showFilePath(event) {
      let uploadedPictures = Object.keys(this.$refs.uploadAddCard.files);
      if (
        this.cardDetails.photo_array &&
        this.cardDetails.photo_array.length + 1 + uploadedPictures.length > 10
      ) {
        this.errors.photo = {
          msg: "You cannot upload more than 10 pictures",
          success: true,
        };
        return;
      }
      var input = event.target;
      let Pictures = Object.keys(input.files);
      if (input.files) {
        Pictures.forEach((index, dataP) => {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.previewPicture.push({
              src: e.target.result,
              isEdited: true,
              defaultImage: this.previewPicture.length == 0 ? true : false,
            });
          };
          this.image = input.files[index];
          reader.readAsDataURL(input.files[index]);
        });
      }
      if (
        this.cardDetails.photo_array &&
        this.cardDetails.photo_array.length == 0 &&
        (this.cardDetails.photo == undefined || this.cardDetails.photo == "")
      ) {
        uploadedPictures.forEach((index, imges) => {
          if (index == 0) {
            this.cardDetails.photo = this.$refs.uploadAddCard.files[index];
          } else {
            this.cardDetails.photo_array.push(
              this.$refs.uploadAddCard.files[index]
            );
          }
        });
      } else {
        uploadedPictures.forEach((index, imges) => {
          this.cardDetails.photo_array.push(
            this.$refs.uploadAddCard.files[index]
          );
        });
      }
      //this.cardDetails.photo = this.$refs.uploadAddCard.files[0];
      // if(this.$refs.uploadAddCard.files.length>1){
      //   this.cardDetails.photo_array=this.$refs.uploadAddCard.files;
      // }
      if (this.cardDetails.photo) {
        this.photoChangeFlag = true;
        uploadedPictures.forEach((index, uploadedfile) => {
          if (index == 0) {
            this.validateUploadPhoto(this.cardDetails.photo);
          } else {
            this.validateUploadPhoto(this.cardDetails.photo_array[index]);
          }
          let format = this.$refs.uploadAddCard.files[index].type
            .split("/")
            .pop();
          if (
            this.$refs.uploadAddCard.files[index].size / 1048576 >
            this.$maxFileSize
          ) {
            this.errors.photo = {
              msg: "Photo size must be less than " + this.$maxFileSize + " MB",
              success: true,
            };
          } else {
            this.errors.photo = {
              msg: "",
              success: false,
            };
            if (!this.$photoFormats.includes(format)) {
              this.errors.photo = {
                msg: "Please select a valid photo format",
                success: true,
              };
            } else {
              this.errors.photo = {
                msg: "",
                success: false,
              };
            }
          }
        });
      } else {
        this.errors.photo = {
          msg: "Upload Photo is required",
          success: true,
        };
      }
    },
    updateRule(rule) {
      this.cardDetails.active_rules_check = rule;
    },
    async getCardsList() {
      await this.$axios
        .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetIssuerCards, {
          params: {
            issuerId: this.cardDetails.issuer._id,
            cardId: this.cardDetails._id,
          },
          headers: {
            Authorization: this.$localStorage.get("token"),
          },
        })
        .then(async (res) => {
          if (res.data.success) {
            this.cardsList = res.data.data;
            if (this.cardsList.length == 0) {
              (this.cardDetails.upgrade_card = ""),
                (this.cardDetails.product_change = ""),
                (this.cardDetails.downgrade_card = "");
            }
          } else {
            this.toast(this.genericErrorMessage());
          }
        })
        .catch((e) => {
          if (e.response.status !== 401) {
            this.toast(this.genericErrorMessage());
          }
        });
    },
    getIssuers() {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.IssuerColors, {
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve(
                (this.issuersList = res.data.data),
                (this.filtererdList = res.data.data)
              );
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    async SaveCardBeforeFinalTab() {
      if (
        (await this.beforeFirstTabChange()) &&
        (await this.beforeSecondTabChange()) &&
        (await this.beforeThirdTabChange()) &&
        (await this.beforePerksTabChange())
      ) {
        this.$refs.wiz.changeTab(4, 3);
        this.editCard()
      }
    },
    async editCard() {
      this.cardDetails.points_categories =
        await this.cardDetails.points_categories.map((value) => {
          value.percentage =
            Number(value.percentage) > 0 ? Number(value.percentage) : "";
          value.multiplier = Number(value.multiplier);
          if (value.parentCategoryId) {
            delete value.parentCategoryId;
          }
          return value;
        });

      this.cardDetails.points_categories.forEach((main) => {
        main.removed_subCategories = [];
        let subcat = this.points_categories_option.find(
          (var1) => var1._id == main.points_category
        );
        if (subcat && subcat.subCategories) {
          subcat.subCategories.forEach((fin) => {
            let aab = main.subCategories.find(
              (a) => a.category == fin.category
            );
            if (!aab) {
              if (fin.category != main.points_category) {
                main.removed_subCategories.push({ category: fin.category });
              }
            }
          });
        }
      });

      this.cardDetails.points_categories.forEach((main) => {
        let subcat = this.points_categories_option.find(
          (var1) => var1._id == main.points_category
        );
        if (subcat && subcat.subCategories) {
          subcat.subCategories.forEach((fin) => {
            let aab = main.subCategories.findIndex(
              (a) => a.category == fin.category
            );
            if (aab >= 0) {
              main.subCategories.splice(aab, 1);
            }
          });
        }
      });
      this.cardDetails.points_categories.forEach((main) => {
        if (main.creator_offset == undefined) {
          main.creator_offset = new Date().getTimezoneOffset();
        }
      });
      this.cardDetails.targeted_offers.forEach((main) => {
        if (main.bonusCategory && main.bonusCategory.length > 0) {
          main.bonusCategory.forEach((cat) => {
            if (cat.creator_offset == undefined) {
              cat.creator_offset = new Date().getTimezoneOffset();
            }
          });
        }
      });
      this.cardDetails.activeRules = await this.cardDetails.activeRules.filter(
        function (value) {
          value.effectiveDate = value.effectiveDate
            ? value.effectiveDate
            : new Date();
          return value.rule ? value : null;
        }
      );

      this.validateRules(
        this.cardDetails.activeRules.length,
        this.cardDetails.active_rules_check
      );

      if (!this.errors.rules.success) {
        this.cardDetails.fee_categories =
          await this.cardDetails.fee_categories.map((value) => {
            let fee_cat_id = value.unique_fee_categories_id;
            value = {
              credit_title: value.credit_title ? value.credit_title : "",
              amount: value.amount ? value.amount : 0,
              description: value.description ? value.description : "",
              cutoff_date: value.cutoff_date,
              na_cutoff: value.na_cutoff,
              per_use_amount: value.per_use_amount ? value.per_use_amount : "",
              expiration_date_type: value.expiration_date_type
                ? value.expiration_date_type
                : "",
              custom_dates: value.custom_dates ? value.custom_dates : [],
              expiration_date_addition: value.expiration_date_addition
                ? value.expiration_date_addition
                : "",
              bonus_categories: value.bonus_categories
                ? value.bonus_categories
                : [],
            };

            if (fee_cat_id) {
              value.unique_fee_categories_id = fee_cat_id;
            } else {
              delete value.unique_fee_categories_id;
            }

            if (value.na_cutoff) {
              delete value.cutoff_date;
            }
            delete value.na_cutoff;
            return value;
          });

        for (var i = 0; i < this.cardDetails.perks.length; i++) {
          if (this.cardDetails.perks[i].show == false) {
            this.cardDetails.perks.splice(i, 1);
          }
        }
        this.cardDetails.perks = await this.cardDetails.perks.map((value) => {
          if (value.na_estimated_val) {
            delete value.estimated_value;
          }
          if (value.call_to_action != "track_usage") {
            delete value.track_usage;
          }
          if (value.call_to_action != "mark_as_enrolled") {
            delete value.mark_as_enrolled;
          }
          if (value.call_to_action != "track_earned_status") {
            delete value.earned_status;
          }
          if (value.call_to_action != "track_earned_tiers") {
            delete value.track_earned_tiers;
          }
          return value;
        });
        let newCardDefaultImages = [];
        let newCardOtherImages = [];
        if (
          this.cardDetails.photo_array &&
          this.cardDetails.photo_array.length > 0 &&
          this.previewPicture &&
          this.previewPicture.length > 0
        ) {
          let topIndex = null;
          this.previewPicture.forEach((pictureD, index) => {
            if (pictureD.defaultImage == true && index > 0) {
              let temp = this.cardDetails.photo_array[index - 1];
              this.cardDetails.photo_array.splice(index - 1, 1);
              this.cardDetails.photo_array.unshift(this.cardDetails.photo);
              this.cardDetails.photo = temp;
              topIndex = index;
            }
          });
          if (topIndex != null) {
            let tempFile = this.previewPicture[topIndex];
            this.previewPicture.splice(topIndex, 1);
            this.previewPicture.unshift(tempFile);
          }
        }
        if (this.previewPicture && this.previewPicture.length > 0) {
          this.previewPicture.forEach((pdata, index) => {
            if (pdata.isEdited == true) {
              if (index == 0) {
                newCardDefaultImages.push(this.cardDetails.photo);
              } else {
                newCardOtherImages.push(
                  this.cardDetails.photo_array[index - 1]
                );
              }
            }
          });
        }
        this.cardDetails.photo_array = this.cardDetails.photo_array.filter(
          (a) => {
            if (typeof a !== typeof {}) {
              return a;
            }
            //typeof a != File
          }
        );
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        var data = new FormData();
        data.append("cardId", this.cardDetails._id);
        data.append("issuer", this.cardDetails.issuer._id);
        data.append("name", this.cardDetails.name);
        data.append("card_type", this.cardDetails.card_type);
        data.append(
          "product_change",
          this.cardDetails.product_change ? this.cardDetails.product_change : ""
        );
        data.append(
          "upgrade_card",
          this.cardDetails.upgrade_card ? this.cardDetails.upgrade_card : ""
        );
        data.append(
          "downgrade_card",
          this.cardDetails.downgrade_card ? this.cardDetails.downgrade_card : ""
        );
        if (newCardDefaultImages && newCardDefaultImages.length > 0) {
          newCardDefaultImages.forEach((nFile, index) => {
            data.append("photo", nFile);
          });
        }
        if (newCardOtherImages && newCardOtherImages.length > 0) {
          newCardOtherImages.forEach((nFile, index) => {
            data.append("photo_array", nFile);
          });
        }
        data.append(
          "current_photo_array",
          JSON.stringify(this.cardDetails.photo_array)
        );
        data.append("photo", this.cardDetails.photo);
        data.append("annual_fee", Number(this.cardDetails.annual_fee));
        data.append("effective_fee", Number(this.calculatedFee));
        data.append(
          "fee_categories",
          JSON.stringify(this.cardDetails.fee_categories)
        );
        // data.append('effective_fee_description',this.cardDetails.effective_fee_description);
        if (this.cardDetails.international_transaction_status != "NA") {
          let itval =
            this.cardDetails.international_transaction_status == "yes"
              ? true
              : false;
          data.append("international_transaction", itval);
        }
        data.append("five_twenty_four", this.cardDetails.five_twenty_four);
        data.append(
          "points_categories",
          JSON.stringify(this.cardDetails.points_categories)
        );
        data.append(
          "targeted_offers",
          JSON.stringify(this.cardDetails.targeted_offers)
        );
        data.append(
          "points_description",
          this.cardDetails.points_description
            ? this.cardDetails.points_description
            : ""
        );
        data.append(
          "dynamic_bonus_categoires",
          JSON.stringify(this.dynamic_bonus_categoires)
        );
        data.append(
          "active_rules_check",
          this.cardDetails.active_rules_check == "Yes" &&
            this.cardDetails.activeRules.length > 0
            ? true
            : false
        );
        data.append(
          "activeRules",
          this.cardDetails.active_rules_check == "Yes"
            ? JSON.stringify(this.cardDetails.activeRules)
            : JSON.stringify([])
        );

        data.append("perks", JSON.stringify(this.cardDetails.perks));

        return new Promise(() => {
          this.$axios
            .post(this.$ApiKeys.BASE_URL + this.$EndPoints.EditCard, data, {
              headers: {
                Authorization: this.$localStorage.get("token"),
                "Content-Type": "multipart/form-data",
              },
            })
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                if (
                  this.userAddedBonusCategoryToApprove &&
                  this.userAddedBonusCategoryToApprove.length > 0
                ) {
                  return new Promise(() => {
                    this.$axios
                      .post(
                        this.$ApiKeys.BASE_URL +
                          this.$EndPoints.ApproveBonusCategory,
                        {
                          bonusCategory: JSON.stringify(
                            this.userAddedBonusCategoryToApprove
                          ),
                        },
                        {
                          headers: {
                            Authorization: this.$localStorage.get("token"),
                          },
                        }
                      )
                      .then(async (res) => {
                        this.$vs.loading.close();
                        if (res.data.success) {
                          this.$router.push({
                            name: "bonuscategories",
                          });
                        } else {
                          this.toast(this.genericErrorMessage());
                        }
                      })
                      .catch((e) => {
                        this.$vs.loading.close();
                      });
                  });
                }
                this.$router.push({
                  name: "view-cards",
                  params: { edit: true },
                });
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.data.errors && e.response.data.errors.card) {
                this.$refs.wiz.changeTab(3, 0);
                this.errors.cardName = {
                  msg: e.response.data.errors.card,
                  success: true,
                };
              } else {
                this.errors.cardName = {
                  msg: "",
                  sucess: false,
                };
              }
              if (e.response.data.errors.points_category) {
                this.$refs.wiz.changeTab(3, 2);
                this.errors.pointCategories = {
                  msg: e.response.data.errors.points_category,
                  success: true,
                };
              } else {
                this.errors.pointCategories = {
                  msg: "",
                  success: false,
                };
                if (e.response.data.errors.duplicatePointCategories) {
                  this.$refs.wiz.changeTab(3, 2);
                  this.errors.pointCategories = {
                    msg: e.response.data.errors.duplicatePointCategories,
                    success: true,
                  };
                } else {
                  this.errors.pointCategories = {
                    msg: "",
                    success: false,
                  };
                  if (e.response.data.errors.percentage) {
                    this.$refs.wiz.changeTab(3, 2);
                    this.errors.pointCategories = {
                      msg: e.response.data.errors.percentage,
                      success: true,
                    };
                  }
                  if (e.response.data.errors.perks) {
                    this.$refs.wiz.changeTab(3, 3);
                    let errMessage = "Something went wrong!";

                    if (e.response.data.errors.perks.category) {
                      errMessage = e.response.data.errors.perks.category;
                    }
                    if (e.response.data.errors.perks.estimated_value) {
                      errMessage = e.response.data.errors.perks.estimated_value;
                    }
                    if (e.response.data.errors.perks.key_date) {
                      errMessage = e.response.data.errors.perks.key_date;
                    }
                    if (e.response.data.errors.perks.date_type) {
                      errMessage = e.response.data.errors.perks.date_type;
                    }
                    if (e.response.data.errors.perks.custom_dates) {
                      errMessage = e.response.data.errors.perks.custom_dates;
                    }
                    if (e.response.data.errors.perks.weeks) {
                      errMessage = e.response.data.errors.perks.weeks;
                    }
                    if (e.response.data.errors.perks.months) {
                      errMessage = e.response.data.errors.perks.months;
                    }
                    if (e.response.data.errors.perks.years) {
                      errMessage = e.response.data.errors.perks.years;
                    }
                    if (e.response.data.errors.perks.duplicatePerks) {
                      errMessage = e.response.data.errors.perks.duplicatePerks;
                    }

                    this.errors.perks = {
                      msg: errMessage,
                      success: true,
                    };
                  } else {
                    this.errors.pointCategories = {
                      msg: "",
                      success: false,
                    };
                    if (e.response.data.errors.multiplier) {
                      this.$refs.wiz.changeTab(3, 2);
                      this.errors.pointCategories = {
                        msg: e.response.data.errors.multiplier,
                        success: true,
                      };
                    } else {
                      this.errors.pointCategories = {
                        msg: "",
                        success: false,
                      };
                    }
                  }
                }
              }
              if (e.response.data.errors.duplicateRules) {
                this.errors.rules = {
                  msg: e.response.data.errors.duplicateRules,
                  success: true,
                };
              } else {
                this.errors.rules = {
                  msg: "",
                  success: false,
                };
              }
              if (e.response.data.errors.duplicateCategories) {
                this.$refs.wiz.changeTab(3, 1);
                this.errors.feeCategory = {
                  msg: e.response.data.errors.duplicateCategories,
                  success: true,
                };
              } else {
                this.errors.feeCategory = {
                  msg: "",
                  success: false,
                };
              }
              if (
                !e.response.data.errors &&
                !e.response.data.errors.perks &&
                !e.response.data.errors.card &&
                !e.response.data.errors.points_category &&
                !e.response.data.errors.duplicateRules &&
                !e.response.data.errors.duplicateCategories
              ) {
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
              }
            });
        });
      }
    },
    getRules() {
      return new Promise(async (resolve) => {
        await this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetRules, {
            params: {
              issuerId: this.cardDetails.issuer._id,
            },
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              resolve(
                (this.rulesList = res.data.data),
                this.calculateRulesWidth()
              );
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    async userAddedToTargeted(categories, index) {
      if (categories && categories.length > 0) {
        categories.forEach((data) => {
          data.dynamic_bonus_category = [];
        });
      }
      let mainUserobj = this.userAddedBonusCategoryList[index];
      this.userAddedBonusCategoryToApprove.push(mainUserobj);
      await this.addMainTargetedOffer();
      this.cardDetails.targeted_offers[
        this.cardDetails.targeted_offers.length - 1
      ].bonusCategory.push({
        categories: categories,
        manage_spend_limit: mainUserobj.manage_spend_limit,
        manage_spend_limit_options: {
          spend_limit: mainUserobj.spend_limit,
          points_limit: mainUserobj.points_limit,
          beginningDate: mainUserobj.beginningDate,
          endDate: mainUserobj.endDate,
          date_type: mainUserobj.date_type,
          // apply_spend_limit_to_other_categories: false,
          // categories_in_limit: [
          //   {
          //     category: "",
          //     name: "",
          //     category_in_limit: false,
          //   },
          // ],
        },
        category_type: mainUserobj.type,
        user_reference_id: mainUserobj.userId,
        user_bonus_reference_id: mainUserobj._id,
      });
      this.addAllDynamicCategoriesCheckboxes();
      this.userAddedBonusCategoryList.splice(index, 1);
    },
    rejectUserAddedCategory(index) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve) => {
        this.$axios
          .post(
            this.$ApiKeys.BASE_URL + this.$EndPoints.DenyBonusCategory,
            {
              bonusCategory: JSON.stringify(
                this.userAddedBonusCategoryList[index]
              ),
            },
            {
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            }
          )
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              this.userAddedBonusCategoryList.splice(index, 1);
              this.showDeleteStatus = {
                msg: res.data.data,
                status: true,
              };
              //resolve((this.points_categories_option = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    savepointcategory(index) {
      this.SaveNewCategories(
        this.userAddedBonusCategoryList[index].categories,
        index,
        this.userAddedBonusCategoryList[index]._id,
        this.userAddedBonusCategoryList[index].profileid,
        this.userAddedBonusCategoryList[index].card._id
      );
    },
    SaveNewCategories(BonusCategoriesList, index, id, profile, cardId) {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve) => {
        this.$axios
          .post(
            this.$ApiKeys.BASE_URL + this.$EndPoints.SavePointsCategory,
            {
              BonusCategoriesList: BonusCategoriesList,
              CbcId: id,
              profileId: profile,
              cardId: cardId,
            },
            {
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            }
          )
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              //resolve((this.points_categories_option = res.data.data));
              this.getCategories();
              this.userAddedToTargeted(res.data.data, index);

              if (this.AllApproved == true) {
                this.userAddedCategory.msg =
                  "To save the New Targeted Offer in this card you may proceed to tab 5 and press the save card button";
                this.userAddedCategory.status = true;
              } else {
                this.userAddedCategory.msg =
                  "User Added Points Categories Successfully Approved. To save the New Targeted Offer in this card you may proceed to tab 5 and press the save card button";
                this.userAddedCategory.status = true;
              }
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
    getCategories() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve) => {
        this.$axios
          .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetCategories, {
            headers: {
              Authorization: this.$localStorage.get("token"),
            },
          })
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              resolve((this.points_categories_option = res.data.data));
            } else {
              this.toast(this.genericErrorMessage());
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },

    plotsubcategories() {
      this.cardDetails.points_categories.forEach((main) => {
        let subcat = this.points_categories_option.find(
          (var1) => var1._id == main.points_category
        );
        if (subcat && subcat.subCategories) {
          subcat.subCategories.forEach((fin) => {
            if (main.removed_subCategories) {
              let aab = main.removed_subCategories.find((a) =>
                a.category == fin.category ? fin.category : ""
              );
              let cbb = main.subCategories.find((a) =>
                a.category == fin.category ? fin.category : ""
              );
              if (!aab && !cbb) {
                main.subCategories.push({
                  category: fin.category,
                  order: main.subCategories.length,
                });
              }
            }
          });
        }
      });
    },

    removeSubCategory(index) {
      var a = this.SubCategorypoints.subcategory.splice(index, 1);
      if (a) {
        this.removedSubcategories.push(a);
      }
      this.validateSubCategory();
    },
    handleSelect(index) {
      this.validateSubCategory();
    },
    ManageSubcategory(index, inp2) {
      if (this.cardDetails.points_categories[index].points_category) {
        if (
          this.cardDetails.points_categories[index].subCategories.length > 0 &&
          this.cardDetails.points_categories[index].subCategories[0].category !=
            ""
        ) {
          this.SubCategorypoints.category =
            this.cardDetails.points_categories[index].points_category;
          let temp1 = this.points_categories_option.find(
            (a) =>
              a._id == this.cardDetails.points_categories[index].points_category
          );
          if (temp1) {
            this.SubCategorypoints.name = temp1.name;
            this.SubCategorypoints.order = temp1.order;
          }
          if (inp2 == "show") {
            this.SubCategorypoints.show = true;
          }
          if (
            this.cardDetails.points_categories[index].points_category !=
            this.cardDetails.points_categories[index].parentCategoryId
          ) {
            this.SubCategorypoints.subcategory = [];
            this.SubCategorypoints.parentCategoryId =
              this.SubCategorypoints.category;
          } else {
            this.SubCategorypoints.subcategory =
              this.cardDetails.points_categories[index].subCategories;
            this.SubCategorypoints.parentCategoryId =
              this.SubCategorypoints.category;
          }
        } else {
          this.SubCategorypoints.category =
            this.cardDetails.points_categories[index].points_category;
          let temp1 = this.points_categories_option.find(
            (a) =>
              a._id == this.cardDetails.points_categories[index].points_category
          );
          if (temp1) {
            this.SubCategorypoints.name = temp1.name;
            this.SubCategorypoints.order = temp1.order;
            this.SubCategorypoints.parentCategoryId = temp1._id;
          }
          if (inp2 == "show") {
            this.SubCategorypoints.show = true;
          }
          this.SubCategorypoints.subcategory = [];

          if (!this.cardDetails.points_categories[index].useredit) {
            let tempcat = this.points_categories_option.find(
              (a) =>
                a._id ==
                this.cardDetails.points_categories[index].points_category
            ).subCategories;
            if (tempcat) {
              //   if (this.cardDetails.points_categories[index].subCategories.length > 0) {
              //     this.cardDetails.points_categories[index].subCategories.pop();
              //   }
              tempcat.forEach((cat) => {
                let aab = this.cardDetails.points_categories[
                  index
                ].removed_subCategories.find((a) => a.category == cat.category);
                if (!aab) {
                  this.SubCategorypoints.subcategory.push({
                    category: cat.category.replace(/\s+/g, " "),
                    order: cat.order,
                  });
                }
              });

              this.cardDetails.points_categories[index].subCategories =
                this.SubCategorypoints.subcategory;
              this.cardDetails.points_categories[index].parentCategoryId =
                this.SubCategorypoints.parentCategoryId;
            }
          }
        }
      }
    },
    async addNewSubCategory() {
      if (this.validateSubCategory() == true) {
        await this.SubCategorypoints.subcategory.push({
          category: "",
          order: "",
          useredit: false,
        });
        this.SubCategorypoints.subcategory =
          await this.SubCategorypoints.subcategory.map((value, index) => {
            return {
              category: value.category,
              order: index + 1,
              useredit: value.useredit,
            };
          });
      }
    },
    async hasUniqueNames(inp) {
      var tmpArr = [];
      for (var i = 0; i < inp.length; i++) {
        if (tmpArr.indexOf(inp[i].category) < 0) {
          tmpArr.push(inp[i].category);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      // console.log('indices are: ',indices);
      return true;
    },
    async hasCategoryUniqueNames(inp, categoryType) {
      var tmpArr = [];
      for (var i = 0; i < inp.length; i++) {
        if (inp[i].type == categoryType) {
          if (tmpArr.indexOf(inp[i].points_category) < 0) {
            tmpArr.push(inp[i].points_category);
          } else {
            // this.error.duplicateIndices.push(i);
            return false;
          }
        }
      }
      return true;
    },
    async hasCategoryUniqueNamesGroup(inp, categoryType) {
      for (var i = 0; i < inp.length; i++) {
        var tmpArr = [];
        if (inp[i].type == categoryType) {
          for (var j = 0; j < inp[i].groupCategories.length; j++) {
            tmpArr.push(inp[i].points_category);
            if (tmpArr.indexOf(inp[i].groupCategories[j].points_category) < 0) {
              tmpArr.push(inp[i].groupCategories[j].points_category);
            } else {
              // this.error.duplicateIndices.push(i);
              return false;
            }
          }
        }
      }
      return true;
    },
    async updateCardSubCategories() {
      if (this.validateSubCategory() != true) {
        return;
      } else if (
        (await this.hasUniqueNames(this.SubCategorypoints.subcategory)) != true
      ) {
        this.errors.subCategory.msg = "SubCategories field must be unique";
        this.errors.subCategory.success = true;
        return;
      } else {
        if (this.errors.subCategory.success == true) {
          this.errors.subCategory.msg = "";
          this.errors.subCategory.success = false;
        }
        if (this.removedSubcategories.length > 0) {
          this.SubCategorypoints.useredit = true;
          this.removedSubcategories = [];
        }
        let tempindex = this.cardDetails.points_categories.findIndex(
          (a) => a.points_category == this.SubCategorypoints.category
        );
        if (tempindex >= 0) {
          this.cardDetails.points_categories[tempindex].subCategories =
            this.SubCategorypoints.subcategory;
          this.cardDetails.points_categories[tempindex].parentCategoryId =
            this.SubCategorypoints.parentCategoryId;
          this.cardDetails.points_categories[tempindex].useredit = true;
        }
        this.SubCategorypoints.show = false;
      }
    },
    validateSubCategory() {
      if (this.SubCategorypoints.subcategory.length == 0) {
        return true;
      }
      this.SubCategorypoints.subcategory.forEach((aa) => {
        if (aa.category.trim() == "" || aa.category.length <= 0) {
          this.errors.subCategory.msg = "Please fill out the SubCategory field";
          this.errors.subCategory.success = true;
          return false;
        } else {
          this.errors.subCategory.success = false;
          this.errors.subCategory.msg = "";
        }
      });
      if (this.errors.subCategory.success == true) {
        return false;
      } else {
        return true;
      }
    },

    BacktoMainCategories() {
      if (this.removedSubcategories.length > 0) {
        this.removedSubcategories.forEach((aa) => {
          if (aa && aa[0]) {
            this.SubCategorypoints.subcategory.splice(aa[0].order - 1, 0, {
              category: aa[0].category,
              order: aa[0].order,
            });
          }
        });
        this.removedSubcategories = [];
      }
      //if (this.validateSubCategory() == true) {
      this.SubCategorypoints.show = false;
      this.cardDetails.points_categories.forEach((aa) => {
        let tempindex1 = aa.subCategories.findIndex((a) => a.category == "");
        if (tempindex1 >= 0) {
          aa.subCategories.splice(tempindex1, 1);
        }
      });
      //}
    },
    categorychangeHandler(inp) {
      if (
        this.cardDetails.points_categories[inp].subCategories &&
        this.cardDetails.points_categories[inp].subCategories.length > 0
      ) {
        this.cardDetails.points_categories[inp].subCategories = [];
      }
      this.ManageSubcategory(inp, "notshow");
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  async created() {
    this.getIssuers();
  },
  async mounted() {
    this.cardDetails = this.$route.params.card;

    this.cardDetails.points_description =
      this.cardDetails.points_description &&
      this.cardDetails.points_description !== "undefined"
        ? this.cardDetails.points_description
        : "";
    this.cardDetails.active_rules_check = this.cardDetails.active_rules_check
      ? "Yes"
      : "No";
    this.cardDetails.dining_points_percentage == 0
      ? (this.cardDetails.dining_points_percentage = "")
      : this.cardDetails.dining_points_percentage;
    this.cardDetails.travel_points_percentage == 0
      ? (this.cardDetails.travel_points_percentage = "")
      : this.cardDetails.travel_points_percentage;
    this.cardDetails.grocery_points_percentage == 0
      ? (this.cardDetails.grocery_points_percentage = "")
      : this.cardDetails.grocery_points_percentage;
    this.cardDetails.airfare_points_percentage == 0
      ? (this.cardDetails.airfare_points_percentage = "")
      : this.cardDetails.airfare_points_percentage;
    this.cardDetails.phonebill_points_percentage == 0
      ? (this.cardDetails.phonebill_points_percentage = "")
      : this.cardDetails.phonebill_points_percentage;
    this.cardDetails.dining_points = this.cardDetails.dining_points
      ? this.cardDetails.dining_points
      : 0;
    this.cardDetails.travel_points = this.cardDetails.travel_points
      ? this.cardDetails.travel_points
      : 0;
    this.cardDetails.grocery_points = this.cardDetails.grocery_points
      ? this.cardDetails.grocery_points
      : 0;
    this.cardDetails.airfare_points = this.cardDetails.airfare_points
      ? this.cardDetails.airfare_points
      : 0;
    this.cardDetails.phonebill_points = this.cardDetails.phonebill_points
      ? this.cardDetails.phonebill_points
      : 0;

    this.previewPicture.push({
      src: this.cardDetails.photo,
      isEdited: false,
      defaultImage: true,
    });
    if (
      this.cardDetails.photo_array &&
      this.cardDetails.photo_array.length > 0
    ) {
      this.cardDetails.photo_array.forEach((file, index) => {
        this.previewPicture.push({
          src: this.cardDetails.photo_array[index],
          isEdited: false,
          defaultImage: false,
        });
      });
    }
    EventBus.$emit("resetToggleGroup", true);
    this.cardDetails.upgrade_card = "";
    this.cardDetails.downgrade_card = "";
    this.cardDetails.product_change = "";
    await this.getCardsList();

    this.calculatedFee = this.cardDetails.effective_fee;

    this.cardDetails.upgrade_card = this.$route.params.up
      ? this.$route.params.up._id
      : "";
    this.cardDetails.downgrade_card = this.$route.params.down
      ? this.$route.params.down._id
      : "";
    this.cardDetails.product_change = this.$route.params.pro
      ? this.$route.params.pro._id
      : "";

    this.userAddedBonusCategoryList = this.$route.params.userbonusCategories
      ? this.$route.params.userbonusCategories
      : [];
    if (
      this.userAddedBonusCategoryList &&
      this.userAddedBonusCategoryList.length > 0
    ) {
      this.userAddedBonusCategoryList.forEach((userAdded) => {
        if (userAdded.categories && userAdded.categories.length > 0) {
          if (
            userAdded.categories.some((a) => a.isExistingPointCategory == false)
          ) {
            this.AllApproved = false;
          } else {
            this.AllApproved = true;
          }
        }
      });
      this.$refs.wiz.changeTab(3, 2);
    }
    this.cardDetails.activeRules = await this.cardDetails.activeRules.filter(
      function (value) {
        value.effectiveDate = value.effectiveDate
          ? value.effectiveDate
          : new Date();
        value.rule = value.rule._id ? value.rule._id : "";
        return value.rule ? value : null;
      }
    );
    this.cardDetails.points_categories = this.cardDetails.points_categories
      ? this.cardDetails.points_categories
      : [];
    // await this.cardDetails.points_categories.map((value, index) => {
    //   let tempCategory = {
    //     points_category: value.points_category._id
    //       ? value.points_category._id
    //       : "",
    //     parentCategoryId: value.points_category,
    //     multiplier: value.multiplier ? value.multiplier : 0,
    //     useredit: false,
    //     manage_spend_limit_options: {
    //       spend_limit: value.spend_limit ? value.spend_limit : 0,
    //       beginningDate: value.beginningDate ? value.beginningDate : 0,
    //       endDate: value.endDate ? value.endDate : 0,
    //       date_type: value.date_type ? value.date_type : "",
    //       apply_spend_limit_to_other_categories: false,
    //     },
    //     manage_spend_limit: value.manage_spend_limit
    //       ? value.manage_spend_limit
    //       : false,
    //     groupCategories: [],
    //     type: value.type,
    //   };
    //   if (value.groupCategories && value.groupCategories.length > 0) {
    //     value.groupCategories.forEach((data) => {
    //       tempCategory.groupCategories.push({
    //         points_category: data.points_category,
    //         multiplier: data.multiplier,
    //         percentage: data.percentage,
    //       });
    //     });
    //   }
    //   this.cardDetails.points_categories[index] = tempCategory;
    // });
    this.cardDetails.points_categories =
      await this.cardDetails.points_categories.map((value, index) => {
        if (value.manage_spend_limit_options == undefined) {
          value.manage_spend_limit_options = {};
        }
        return value;
      });

    this.cardDetails.points_categories =
      await this.cardDetails.points_categories.filter(function (value) {
        value.points_category = value.points_category._id
          ? value.points_category._id
          : "";
        value.parentCategoryId = value.points_category;
        value.multiplier = value.multiplier ? value.multiplier : 0;
        value.useredit = false;
        value.type = value.type ? value.type : "single";
        value.groupCategories = value.groupCategories;
        value.manage_spend_limit_options = {
          spend_limit: value.spend_limit,
          points_limit: value.points_limit,
          beginningDate: value.beginningDate,
          endDate: value.endDate,
          date_type: value.date_type ? value.date_type : "",
          apply_spend_limit_to_other_categories: false,
        };
        return value.points_category ? value : null;
      });

    this.cardDetails.targeted_offers = this.cardDetails.targeted_offers
      ? this.cardDetails.targeted_offers
      : [];
    this.cardDetails.targeted_offers =
      await this.cardDetails.targeted_offers.map((value, index) => {
        if (value.bonusCategory && value.bonusCategory.length > 0) {
          value.bonusCategory.forEach((data) => {
            if (data.manage_spend_limit_options == undefined) {
              data.manage_spend_limit_options = {};
            }
          });
        }

        return value;
      });

    this.cardDetails.targeted_offers =
      await this.cardDetails.targeted_offers.filter(function (value) {
        if (value.bonusCategory && value.bonusCategory.length > 0) {
          value.bonusCategory.forEach((data) => {
            data.categories = data.categories ? data.categories : [];
            data.manage_spend_limit_options = {
              spend_limit: data.spend_limit,
              points_limit: data.points_limit,
              beginningDate: data.beginningDate,
              endDate: data.endDate,
              date_type: data.date_type ? data.date_type : "",
            };
          });
        }
        return value ? value : null;
      });
    /////////////////////////

    ////////////////////////
    this.cardDetails.perks = this.cardDetails.perks
      ? this.cardDetails.perks
      : [];

    await this.cardDetails.perks.map((value, index) => {
      let tempPerk = this.cardDetails.perks[index];

      if (!value.key_date_addition) {
        tempPerk.key_date_addition = {
          weeks: 0,
          months: 0,
          years: 0,
        };
      }
      if (value.earned_status == undefined) {
        tempPerk.earned_status = {
          earned_perk_token: "",
          add_new_perk: false,
        };
      }
      if (value.mark_as_enrolled == undefined) {
        tempPerk.mark_as_enrolled = {
          option_value: "",
          master_cutoff_date: "",
          track_usage_type: "single_use_one_time",
          multiple_use_limit: 0,
        };
      }
      if (value.track_earned_tiers == undefined) {
        tempPerk.track_earned_tiers = {
          option_value: "",
          input_text: "",
          number_of_limit: 0,
        };
      }
      if (value.track_usage == undefined) {
        tempPerk.track_usage = {
          option_value: "",
          multiple_use_limit: 0,
        };
      }
      if (value.bonus_categories == undefined) {
        tempPerk.bonus_categories = [];
      }

      if (value.earned_status.earned_perk_token == undefined) {
        tempPerk.earned_status.earned_perk_token = "";
      }
      if (value.mark_as_enrolled.option_value == undefined) {
        tempPerk.mark_as_enrolled.option_value = "";
      }
      if (value.track_earned_tiers.option_value == undefined) {
        tempPerk.track_earned_tiers.option_value = "";
      }
      if (value.track_usage.option_value == undefined) {
        tempPerk.track_usage.option_value = "";
      }
      if (value.hasOwnProperty("estimated_value")) {
        tempPerk.na_estimated_val = false;
      } else {
        tempPerk.na_estimated_val = true;
      }

      if (value.show == undefined) {
        tempPerk.show = true;
      }
      this.cardDetails.perks[index] = tempPerk;
    });

    this.cardDetails.perks.forEach((per) => {
      if (per.token) {
        let temp1 = this.cardDetails.perks.findIndex(
          (a) => a.earned_status.earned_perk_token == per.token
        );
        if (temp1 >= 0) {
          this.cardDetails.perks[temp1].earned_status.earned_perk_token =
            per._id;
          per.token = per._id;

          if (
            this.cardDetails.perks[temp1].earned_status.add_new_perk == true
          ) {
            per.disable = true;
          }
        }
      }
    });

    this.cardDetails.fee_categories = this.cardDetails.fee_categories
      ? this.cardDetails.fee_categories
      : [];

    await this.cardDetails.fee_categories.map((value, index) => {
      let tempCredit = this.cardDetails.fee_categories[index];

      if (!value.expiration_date_addition) {
        tempCredit.expiration_date_addition = {
          weeks: 0,
          months: 0,
          years: 0,
        };
      }
      if (value.bonus_categories == undefined) {
        tempCredit.bonus_categories = [];
      }
      if (value.hasOwnProperty("cutoff_date")) {
        tempCredit.na_cutoff = false;
      } else {
        tempCredit.na_cutoff = true;
        tempCredit.cutoff_date = "";
      }

      this.cardDetails.fee_categories[index] = tempCredit;
    });

    if (this.cardDetails.hasOwnProperty("international_transaction")) {
      this.cardDetails.international_transaction_status = this.cardDetails
        .international_transaction
        ? "yes"
        : "no";
    } else {
      this.cardDetails.international_transaction_status = "NA";
    }
    if (
      this.cardDetails.dynamic_bonus_categoires &&
      this.cardDetails.dynamic_bonus_categoires.length > 0
    ) {
      this.dynamic_bonus_categoires = this.cardDetails.dynamic_bonus_categoires;
    }
    this.getRules();
    await this.getCategories();
    await this.plotsubcategories();
  },
  components: {
    FormWizard,
    TabContent,
    UploadCloudIcon,
    PlusSquareIcon,
    MinusSquareIcon,
    Datepicker,
    Editor,
    Index,
    draggable,
    MenuIcon,
    VueLoadImage,
    modal,
    pointCategorymodal,
  },
  mixins: [clickaway],
};
</script>

<style>
@import "../../../../assets/css/tinymce.css";
@import "./style.css";
@import "../../../../assets/css/add-edit-approve-card.css";
</style>



































/* 

  

*/




